
// // // import Router from 'next/router';
// // // import FilterItem from './FilterItem';
// // // import React, { useEffect, useState } from 'react';
// // // import { useCookies } from 'react-cookie';
// // // import {
// // //     hamburgerMenu,
// // //     profilePhoto,
// // //     notificationBell,
// // //     downArrow,
// // //   } from "../../../public/assets/icons"
// // // import {
// // //   userLight,
// // //   triangle,
// // //   helpCenter,
// // //   modalSettings,
// // //   logout,
// // //   check,
// // // } from '../../../assets/icons';
// // // import { logout as logoutFn } from '../../../utils/local-storage';
// // // // import FilterItem from '../../elements/filter-menu-item';
// // // import SidebarMenuItem from '../../elements/sidebar-menu-item';
// // // import CalendarModal from '../../elements/calendar';

// // // const Filter = ({ setLogoutLoading }) => {
// // // //   const [active, setActive] = useState('yesterday');
// // //   const [closeCalendar, setCloseCalendar] = useState(true);
// // //   const [date, setDate] = useState([new Date(), new Date()]);
// // //   const [cookie, setCookie, removeCookies] = useCookies();
// // // //   const [showCalendarModal, setShowCalendarModal] = useState(false); // State to track the display of the calendar modal

// // //   // Function to toggle the display of the calendar modal
// // // //   const toggleCalendarModal = () => {
// // // //     setShowCalendarModal(!showCalendarModal);
// // // //   };

// // //   const handleApply = () => {
// // //     setCloseCalendar(true);
// // //   };

// // // const [active, setActive] = useState('yesterday');
// // // const [dateRange, setDateRange] = useState({ start: null, end: null });
// // // const [showCalendarModal, setShowCalendarModal] = useState(false);

// // // const [dropdownVisible, setDropdownVisible] = useState(false); // State to track dropdown visibility

// // //   // Function to toggle the display of the calendar modal

// // //   // Function to toggle dropdown visibility
// // //   const toggleDropdown = () => {
// // //     setDropdownVisible(!dropdownVisible);
// // //   };

// // //   // Function to handle applying the date range from the calendar modal

// // // // Function to toggle the display of the calendar modal
// // // const toggleCalendarModal = () => {
// // //   setShowCalendarModal(!showCalendarModal);
// // // };

// // // // Function to handle applying the date range from the calendar modal
// // // const handleApplyDateRange = () => {
// // //   // Close the modal
// // //   toggleCalendarModal();
// // //   // Logic to filter transactions based on the selected date range
// // //   // You can implement this based on your application's data retrieval mechanism
// // // };
// // //   return (
// // //     <section className=" relative  z-[100%] flex items-center flex-col w-full  justify-between ">
// // //       <div className="absolute ml-32">
// // //         <Image src={triangle} alt="triangle" />
// // //       </div>

// // //       <div className=" relative bg-dash-green py-2 pl-5 lg:w-[207px] w-full m-auto mt-3">

// // //       <div className="dropdown-toggle  top-16 right-3 z-50 " onClick={toggleDropdown}>
// // //           <p className="dropdown-title">Filters</p>
// // //           <Image src={triangle} alt="dropdown" className={`dropdown-icon ${dropdownVisible ? 'open' : ''}`} />
// // //         </div>
// // //         {dropdownVisible && (

// // //             <div className="dropdown-content ">
// // //             <FilterItem
// // //           title="Today"
// // //           baseIcon={<Image src={userLight} alt="user light" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={() => setActive('today')}
// // //           active={active === 'today'}
// // //           // Implement filtering logic for 'Today'
// // //         />
// // //         <FilterItem
// // //           title="Yesterday"
// // //           baseIcon={<Image src={helpCenter} alt="help center" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={() => setActive('yesterday')}
// // //           active={active === 'yesterday'}
// // //           // Implement filtering logic for 'Yesterday'
// // //         />

// // //         <FilterItem
// // //           title="Past Week"
// // //           baseIcon={<Image src={helpCenter} alt="help center" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={() => setActive('Past Week')}
// // //           active={active === 'Past Week'}

// // //         />
// // //         <FilterItem
// // //           title="Past Month"
// // //           baseIcon={<Image src={helpCenter} alt="help center" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={() => setActive('Past Month')}
// // //           active={active === 'Past Month'}

// // //         />
// // //         <FilterItem
// // //           title="Custom Range"
// // //           baseIcon={<Image src={userLight} alt="user light" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={toggleCalendarModal}
// // //           active={showCalendarModal}
// // //         />
// // //         <FilterItem
// // //           title="Filter All"
// // //           baseIcon={<Image src={userLight} alt="user light" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={toggleCalendarModal}
// // //           active={showCalendarModal}
// // //         />

// // //         {showCalendarModal && (
// // //           <CalendarModal
// // //             closeCalendar={toggleCalendarModal}
// // //           date={date}
// // //           setDate={setDate}
// // //           selectRange={true}
// // //           handleApply={handleApply}// Pass toggle function as closeCalendar prop
// // //             // Other props as needed
// // //           />
// // //         )}

// // //         {/* <CalendarModal/> */}
// // //         {/* <FilterItem
// // //           title="Settings"
// // //           baseIcon={<Image src={modalSettings} alt="modal settings" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={() => setActive('past-week')}
// // //           active={active === 'past-week'}
// // //           url="#"
// // //         /> */}
// // //         {/* <FilterItem
// // //           title="Logout"
// // //           baseIcon={<Image src={logout} alt="logout" />}
// // //           activeIcon={<Image src={check} alt="check" />}
// // //           onClick={() => {
// // //             removeCookies('authToken', { path: '/' });
// // //             removeCookies('user', { path: '/' });
// // //             removeCookies('userId', { path: '/' });
// // //             removeCookies('firstName', { path: '/' });
// // //             removeCookies('role', { path: '/' });
// // //             removeCookies('vendorId', { path: '/' });
// // //             logoutFn();
// // //             setLogoutLoading(true);
// // //             Router.push('/');
// // //             // setTimeout(() => Router.reload(), 1000);
// // //           }}
// // //           active={active === 'past-month'}
// // //           // url="#"
// // //         /> */}
// // //       </div>
// // //       )}
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Filter;
// // // // {new Dat}

// // // import React, { useState, useEffect } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { addDays, subDays, startOfWeek, startOfMonth, startOfYear, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data }) => {
// // //   const [filteredData, setFilteredData] = useState([]);
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(today);
// // //       setEndDate(today);
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(yesterday);
// // //       setEndDate(yesterday);
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7));
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(lastWeekStart);
// // //       setEndDate(lastWeekEnd);
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = subDays(today, 1);
// // //       setStartDate(lastMonthStart);
// // //       setEndDate(lastMonthEnd);
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   useEffect(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         const createdAt = parseISO(item.createdAt);
// // //         return createdAt >= startDate && createdAt <= endDate;
// // //       });
// // //       setFilteredData(filtered);
// // //     } else {
// // //       setFilteredData(data);
// // //     }
// // //   }, [startDate, endDate, data]);

// // //   return (
// // //     <div>
// // //       <div>
// // //         <button onClick={filterOptions.today}>Today</button>
// // //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// // //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// // //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// // //         <button onClick={filterOptions.all}>All</button>
// // //       </div>
// // //       <div>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //         />
// // //       </div>
// // //       <div>
// // //         {filteredData.map((item, index) => (
// // //           <div key={index}>
// // //             <p>{item.name}</p>
// // //             <p>{item.createdAt}</p>
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data }) => {
// // //   const [filteredData, setFilteredData] = useState([]);
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   useEffect(() => {
// // //     // Check if data is defined and not null before filtering
// // //     if (data && data.length > 0) {
// // //       setFilteredData(data);
// // //     }
// // //   }, [data]);

// // //   // const filterOptions = {
// // //   //   today: () => {
// // //   //     const today = new Date();
// // //   //     setStartDate(today);
// // //   //     setEndDate(today);
// // //   //   },
// // //   //   yesterday: () => {
// // //   //     const yesterday = subDays(new Date(), 1);
// // //   //     setStartDate(yesterday);
// // //   //     setEndDate(yesterday);
// // //   //   },
// // //   //   lastWeek: () => {
// // //   //     const today = new Date();
// // //   //     const lastWeekStart = startOfWeek(subDays(today, 7));
// // //   //     const lastWeekEnd = subDays(today, 1);
// // //   //     setStartDate(lastWeekStart);
// // //   //     setEndDate(lastWeekEnd);
// // //   //   },
// // //   //   lastMonth: () => {
// // //   //     const today = new Date();
// // //   //     const lastMonthStart = startOfMonth(subDays(today, 30));
// // //   //     const lastMonthEnd = subDays(today, 1);
// // //   //     setStartDate(lastMonthStart);
// // //   //     setEndDate(lastMonthEnd);
// // //   //   },
// // //   //   all: () => {
// // //   //     setStartDate(null);
// // //   //     setEndDate(null);
// // //   //   }
// // //   // };
// // //   // const filterOptions = {
// // //   //   today: () => {
// // //   //     const today = new Date();
// // //   //     setStartDate(today);
// // //   //     setEndDate(today);
// // //   //   },
// // //   //   yesterday: () => {
// // //   //     const yesterday = subDays(new Date(), 1);
// // //   //     setStartDate(yesterday);
// // //   //     setEndDate(yesterday);
// // //   //   },
// // //   //   lastWeek: () => {
// // //   //     const today = new Date();
// // //   //     const lastWeekStart = startOfWeek(subDays(today, 7));
// // //   //     const lastWeekEnd = subDays(today, 1);
// // //   //     setStartDate(lastWeekStart);
// // //   //     setEndDate(lastWeekEnd);
// // //   //   },
// // //   //   lastMonth: () => {
// // //   //     const today = new Date();
// // //   //     const lastMonthStart = startOfMonth(subDays(today, 30));
// // //   //     const lastMonthEnd = subDays(today, 1);
// // //   //     setStartDate(lastMonthStart);
// // //   //     setEndDate(lastMonthEnd);
// // //   //   },
// // //   //   all: () => {
// // //   //     setStartDate(null);
// // //   //     setEndDate(null);
// // //   //   }
// // //   // };

// // //   const filterOptions = {
// // //     today: () => {
// // //       console.log("Filtering for today");
// // //       const today = new Date();
// // //       setStartDate(today);
// // //       setEndDate(today);
// // //     },
// // //     yesterday: () => {
// // //       console.log("Filtering for yesterday");
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(yesterday);
// // //       setEndDate(yesterday);
// // //     },
// // //     lastWeek: () => {
// // //       console.log("Filtering for last week");
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7));
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(lastWeekStart);
// // //       setEndDate(lastWeekEnd);
// // //     },
// // //     lastMonth: () => {
// // //       console.log("Filtering for last month");
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = subDays(today, 1);
// // //       setStartDate(lastMonthStart);
// // //       setEndDate(lastMonthEnd);
// // //     },
// // //     all: () => {
// // //       console.log("Filtering for all");
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   // useEffect(() => {
// // //   //   if (startDate && endDate) {
// // //   //     const filtered = data.filter(item => {
// // //   //       const createdAt = parseISO(item.createdAt);
// // //   //       return createdAt >= startDate && createdAt <= endDate;
// // //   //     });
// // //   //     setFilteredData(filtered);
// // //   //   } else {
// // //   //     setFilteredData(data);
// // //   //   }
// // //   // }, [startDate, endDate, data]);
// // //   useEffect(() => {
// // //     console.log("Filtering data...");
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         const createdAt = parseISO(item.createdAt);
// // //         return createdAt >= startDate && createdAt <= endDate;
// // //       });
// // //       setFilteredData(filtered);
// // //     } else {
// // //       setFilteredData(data);
// // //     }
// // //   }, [startDate, endDate, data]);

// // //   // useEffect(() => {
// // //   //   if (startDate && endDate) {
// // //   //     const filtered = data.filter(item => {
// // //   //       const createdAt = parseISO(item.createdAt);
// // //   //       return createdAt >= startDate && createdAt <= endDate;
// // //   //     });
// // //   //     setFilteredData(filtered);
// // //   //   } else {
// // //   //     setFilteredData(data);
// // //   //   }
// // //   // }, [startDate, endDate, data]);

// // //   return (
// // //     <div>
// // //       <div>
// // //         <button onClick={filterOptions.today}>Today</button>
// // //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// // //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// // //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// // //         <button onClick={filterOptions.all}>All</button>
// // //       </div>
// // //       <div>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //         />
// // //       </div>
// // //       <div>
// // //         {filteredData.map((item, index) => (
// // //           <div key={index}>
// // //             <p>{item.name}</p>
// // //             <p>{item.createdAt}</p>
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data, onFilter, }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(today);
// // //       setEndDate(today);
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(yesterday);
// // //       setEndDate(yesterday);
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7));
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(lastWeekStart);
// // //       setEndDate(lastWeekEnd);
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = subDays(today, 1);
// // //       setStartDate(lastMonthStart);
// // //       setEndDate(lastMonthEnd);
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   useEffect(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         const createdAt = parseISO(item.createdAt);
// // //         return createdAt >= startDate && createdAt <= endDate;
// // //       });
// // //       onFilter(filtered);
// // //     } else {
// // //       onFilter(data);
// // //     }
// // //   }, [startDate, endDate, data, onFilter]);

// // //   return (
// // //     <div className='w-1/2 flex items-center'>
// // //       <div className='flex'>
// // //         <button onClick={filterOptions.today}>Today</button>
// // //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// // //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// // //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// // //         <button onClick={filterOptions.all}>All</button>
// // //       </div>
// // //       <div>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data, onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 }); // Assuming week starts on Monday
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   useEffect(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         const createdAt = parseISO(item.createdAt);
// // //         return createdAt >= startDate && createdAt <= endDate;
// // //       });
// // //       onFilter(filtered);
// // //     } else {
// // //       onFilter(data);
// // //     }
// // //   }, [startDate, endDate, data, onFilter]);

// // //   return (
// // //     <div className='w-1/2 flex items-center'>
// // //       <div className='flex'>
// // //         <button onClick={filterOptions.today}>Today</button>
// // //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// // //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// // //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// // //         <button onClick={filterOptions.all}>All</button>
// // //       </div>
// // //       <div>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;
// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data, onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //       console.log('Today Start Date:', startDate);
// // //       console.log('Today End Date:', endDate);
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 }); // Assuming week starts on Monday
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   const applyFilter = useCallback(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         const createdAt = parseISO(item.createdAt);
// // //         return createdAt >= startDate && createdAt <= endDate;
// // //       });
// // //       console.log('Filtered Array:', filtered);
// // //       onFilter(filtered);
// // //     } else {
// // //       onFilter(data);
// // //     }
// // //   }, [startDate, endDate, data, onFilter]);

// // //   useEffect(() => {
// // //     applyFilter();
// // //   }, [applyFilter]);

// // //   return (
// // //     <div className=" mt-2  p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap">
// // //         <div className='flex flex-row space-y-2 '>
// // //             <button onClick={filterOptions.today} className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px]  w-auto lg:w-[100px]">Today</button>
// // //             <button onClick={filterOptions.yesterday} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Yest<br className='lg:hidden flex'/>erday</button>
// // //             <button onClick={filterOptions.lastWeek} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1  w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/> Week</button>
// // //             <button onClick={filterOptions.lastMonth} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1  w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/>Month</button>
// // //             <button onClick={filterOptions.all} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1  w-auto lg:w-[100px] text-[12px]">All</button>
// // //           </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px]  outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>

// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data, onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);
// // //  const filterComponent=({onFilterChange})=>{
// // // const [filterTye, setFilterType]= useState(" ")
// // // const [customRange, setCustomRange] = useState([null, null])
// // // const handleFilterChange=()=>{

// // // }
// // //  }

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //       console.log('Today Start Date:', startDate);
// // //       console.log('Today End Date:', endDate);
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //       console.log('Yesterday Start Date:', startDate);
// // //       console.log('Yesterday End Date:', endDate);
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 }); // Assuming week starts on Monday
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //       console.log('Last Week Start Date:', startDate);
// // //       console.log('Last Week End Date:', endDate);
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //       console.log('Last Month Start Date:', startDate);
// // //       console.log('Last Month End Date:', endDate);
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   // const applyFilter = useCallback(() => {
// // //   //   if (startDate && endDate) {
// // //   //     const filtered = data.filter(item => {
// // //   //       try {
// // //   //         console.log('Original createdAt:', item.createdAt);
// // //   //         const createdAt = parseISO(item.createdAt);
// // //   //         return createdAt >= startDate && createdAt <= endDate;
// // //   //       } catch (error) {
// // //   //         console.error('Error parsing date:', item.createdAt, error);
// // //   //         return false;
// // //   //       }
// // //   //     });
// // //   //     console.log('Filtered Array:', filtered);
// // //   //     onFilter(filtered);
// // //   //   } else {
// // //   //     onFilter(data);
// // //   //   }
// // //   // }, [startDate, endDate, data, onFilter]);
// // //   const applyFilter = useCallback(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {

// // //         if (item.createdAt) {
// // //           try {
// // //             console.log('Original createdAt:', item.createdAt);
// // //             const createdAt = parseISO(item.createdAt);
// // //             return createdAt >= startDate && createdAt <= endDate;
// // //           } catch (error) {
// // //             console.error('Error parsing date:', item.createdAt, error);
// // //             return false;
// // //           }
// // //         } else {
// // //           return false; // Skip items without a valid createdAt property
// // //         }
// // //       });
// // //       console.log('Filtered Array:', filtered);
// // //       onFilter(filtered);
// // //     } else {
// // //       onFilter(data);
// // //     }
// // //   }, [startDate, endDate, data, onFilter]);
// // //   useEffect(() => {
// // //     applyFilter();
// // //   }, [applyFilter]);

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button

// // //         onClick={() => filterOptions.today()}
// // //         className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">Today</button>
// // //         <button onClick={()=>filterOptions.yesterday()} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Yest<br className='lg:hidden flex'/>erday</button>
// // //         <button onClick={filterOptions.lastWeek} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/> Week</button>
// // //         <button onClick={filterOptions.lastMonth} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/>Month</button>
// // //         <button onClick={filterOptions.all} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">All</button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO, lastDayOfYear, startOfYear, endOfYear } from 'date-fns';

// // // const FilterComponent = ({ data, onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   const applyFilter = useCallback(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         if (item.launchDate) {
// // //           try {
// // //             const launchDate = parseISO(item.launchDate);
// // //             return launchDate >= startDate && launchDate <= endDate;
// // //           } catch (error) {
// // //             console.error('Error parsing date:', item.launchDate, error);
// // //             return false;
// // //           }
// // //         } else {
// // //           return false;
// // //         }
// // //       });
// // //       onFilter(filtered);
// // //     } else {
// // //       onFilter(data);
// // //     }
// // //   }, [startDate, endDate, data, onFilter]);

// // //   useEffect(() => {
// // //     applyFilter();
// // //   }, [applyFilter]);

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button
// // //           onClick={() => filterOptions.today()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// // //           Today
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.yesterday()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Yesterday
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastWeek()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Week
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastMonth()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Month
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.all()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           All
// // //         </button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // // const FilterComponent = ({ data, onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     // lastDayOfYear: () => {
// // //     //   const today = new Date();
// // //     //   const lastMonthStart = startOfYear(subDays(today, 365));
// // //     //   const lastMonthEnd = endOfYear(subDays(today, 365));
// // //     //   setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //     //   setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     // },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   const applyFilter = useCallback(() => {
// // //     if (startDate && endDate) {
// // //       const filtered = data.filter(item => {
// // //         const dateField = item.launchDate || item.createdAt || item.Date;
// // //         if (dateField) {
// // //           try {
// // //             const date = parseISO(dateField);
// // //             return date >= startDate && date <= endDate;
// // //           } catch (error) {
// // //             console.error('Error parsing date:', dateField, error);
// // //             return false;
// // //           }
// // //         } else {
// // //           return false;
// // //         }
// // //       });
// // //       onFilter(filtered);
// // //     } else {
// // //       onFilter(data);
// // //     }
// // //   }, [startDate, endDate, data, onFilter]);

// // //   useEffect(() => {
// // //     applyFilter();
// // //   }, [applyFilter]);

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button
// // //           onClick={() => filterOptions.today()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// // //           Today
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.yesterday()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Yesterday
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastWeek()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Week
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastMonth()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Month
// // //         </button>
// // //         {/* <button
// // //           onClick={() => filterOptions.lastDayOfYear()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Year
// // //         </button> */}
// // //         <button
// // //           onClick={() => filterOptions.all()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           All
// // //         </button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useCallback, useEffect } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { fetchAffiliateRecentSales } from '../../../api-client/dashboard';
// // // // import { fetchAffiliateRecentSales } from './api'; // Adjust the import based on your project structure

// // // const FilterComponent = ({ token, onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   const applyFilter = useCallback(() => {
// // //     const pageNumber = 1; // Adjust as necessary
// // //     const pageSize = 25; // Adjust as necessary
// // //     const searchText = ""; // Adjust as necessary

// // //     fetchAffiliateRecentSales({ token, pageNumber, pageSize, searchText, startDate, endDate })
// // //       .then(response => onFilter(response.data))
// // //       .catch(error => console.error('Error fetching data:', error));
// // //   }, [startDate, endDate, token, onFilter]);

// // //   useEffect(() => {
// // //     applyFilter();
// // //   }, [applyFilter]);

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button
// // //           onClick={() => filterOptions.today()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// // //           Today
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.yesterday()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Yesterday
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastWeek()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Week
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastMonth()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Month
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.all()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           All
// // //         </button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState, useEffect, useCallback } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import "react-datepicker/dist/react-datepicker.css";
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';

// // // const FilterComponent = ({ onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// // //       const lastWeekEnd = subDays(today, 1);
// // //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// // //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //   };

// // //   const applyFilter = useCallback(() => {
// // //     onFilter({ startDate, endDate });
// // //   }, [startDate, endDate, onFilter]);

// // //   useEffect(() => {
// // //     applyFilter();
// // //   }, [applyFilter, startDate, endDate]);
// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button
// // //           onClick={() => filterOptions.today()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// // //           Today
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.yesterday()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Yesterday
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastWeek()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Week
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.lastMonth()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Month
// // //         </button>
// // //         <button
// // //           onClick={() => filterOptions.all()}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           All
// // //         </button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import "react-datepicker/dist/react-datepicker.css";
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';

// // // const FilterComponent = ({ onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       const start = new Date(today.setHours(0, 0, 0, 0));
// // //       const end = new Date(today.setHours(23, 59, 59, 999));
// // //       setStartDate(start);
// // //       setEndDate(end);
// // //       onFilter({ startDate: start, endDate: end });
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       const start = new Date(yesterday.setHours(0, 0, 0, 0));
// // //       const end = new Date(yesterday.setHours(23, 59, 59, 999));
// // //       setStartDate(start);
// // //       setEndDate(end);
// // //       onFilter({ startDate: start, endDate: end });
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// // //       const lastWeekEnd = subDays(today, 1);
// // //       const start = new Date(lastWeekStart.setHours(0, 0, 0, 0));
// // //       const end = new Date(lastWeekEnd.setHours(23, 59, 59, 999));
// // //       setStartDate(start);
// // //       setEndDate(end);
// // //       onFilter({ startDate: start, endDate: end });
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       const start = new Date(lastMonthStart.setHours(0, 0, 0, 0));
// // //       const end = new Date(lastMonthEnd.setHours(23, 59, 59, 999));
// // //       setStartDate(start);
// // //       setEndDate(end);
// // //       onFilter({ startDate: start, endDate: end });
// // //     },
// // //     all: () => {
// // //       setStartDate(null);
// // //       setEndDate(null);
// // //       onFilter({ startDate: null, endDate: null });
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //     onFilter({ startDate: start, endDate: end });
// // //   };

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button
// // //           onClick={filterOptions.today}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// // //           Today
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.yesterday}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Yesterday
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.lastWeek}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Week
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.lastMonth}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Month
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.all}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           All
// // //         </button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import "react-datepicker/dist/react-datepicker.css";
// // // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';
// // // import { useCookies } from 'react-cookie';

// // // const FilterComponent = ({ onFilter }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);
// // //   const [cookies, setCookie] = useCookies(['filter']);

// // //   const setFilter = (start, end) => {
// // //     setStartDate(start);
// // //     setEndDate(end);
// // //     onFilter({ startDate: start, endDate: end });

// // //     // Set the filter in cookies
// // //     setCookie('filter', { startDate: start, endDate: end }, { path: '/' });
// // //   };

// // //   const filterOptions = {
// // //     today: () => {
// // //       const today = new Date();
// // //       const start = new Date(today.setHours(0, 0, 0, 0));
// // //       const end = new Date(today.setHours(23, 59, 59, 999));
// // //       setFilter(start, end);
// // //     },
// // //     yesterday: () => {
// // //       const yesterday = subDays(new Date(), 1);
// // //       const start = new Date(yesterday.setHours(0, 0, 0, 0));
// // //       const end = new Date(yesterday.setHours(23, 59, 59, 999));
// // //       setFilter(start, end);
// // //     },
// // //     lastWeek: () => {
// // //       const today = new Date();
// // //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// // //       const lastWeekEnd = subDays(today, 1);
// // //       const start = new Date(lastWeekStart.setHours(0, 0, 0, 0));
// // //       const end = new Date(lastWeekEnd.setHours(23, 59, 59, 999));
// // //       setFilter(start, end);
// // //     },
// // //     lastMonth: () => {
// // //       const today = new Date();
// // //       const lastMonthStart = startOfMonth(subDays(today, 30));
// // //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// // //       const start = new Date(lastMonthStart.setHours(0, 0, 0, 0));
// // //       const end = new Date(lastMonthEnd.setHours(23, 59, 59, 999));
// // //       setFilter(start, end);
// // //     },
// // //     all: () => {
// // //       setFilter(null, null);
// // //     }
// // //   };

// // //   const handleCustomRange = (dates) => {
// // //     const [start, end] = dates;
// // //     setFilter(start, end);
// // //   };

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button
// // //           onClick={filterOptions.today}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// // //           Today
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.yesterday}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Yesterday
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.lastWeek}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Week
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.lastMonth}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           Last Month
// // //         </button>
// // //         <button
// // //           onClick={filterOptions.all}
// // //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// // //           All
// // //         </button>
// // //       </div>
// // //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={handleCustomRange}
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           selectsRange
// // //           maxDate={new Date()}
// // //           minDate={subDays(new Date(), 365 * 3)}
// // //           placeholderText="Custom Range"
// // //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// // //         />
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default FilterComponent;

// // // import React, { useState } from 'react';
// // // import DatePicker from 'react-datepicker';
// // // import 'react-datepicker/dist/react-datepicker.css';
// // // import { fetchAffiliateRecentSales } from './yourApiFile';

// // // const DateFilterComponent = ({ token }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const handleDateRange = (range) => {
// // //     let start, end;
// // //     const today = new Date();

// // //     switch (range) {
// // //       case 'today':
// // //         start = end = new Date();
// // //         break;
// // //       case 'yesterday':
// // //         start = end = new Date(today.setDate(today.getDate() - 1));
// // //         break;
// // //       case 'lastWeek':
// // //         start = new Date(today.setDate(today.getDate() - 7));
// // //         end = new Date();
// // //         break;
// // //       case 'lastMonth':
// // //         start = new Date(today.setMonth(today.getMonth() - 1));
// // //         end = new Date();
// // //         break;
// // //       default:
// // //         start = null;
// // //         end = null;
// // //     }

// // //     setStartDate(start);
// // //     setEndDate(end);

// // //     fetchSalesData(start, end);
// // //   };

// // //   const fetchSalesData = (start, end) => {
// // //     fetchAffiliateRecentSales({ token, startDate: start, endDate: end })
// // //       .then(response => {
// // //         console.log('Data fetched successfully:', response.data);
// // //       })
// // //       .catch(error => {
// // //         console.error('Error fetching data:', error);
// // //       });
// // //   };

// // //   const handleCustomRange = () => {
// // //     fetchSalesData(startDate, endDate);
// // //   };

// // //   return (
// // //     <div>
// // //       <button onClick={() => handleDateRange('today')}>Today</button>
// // //       <button onClick={() => handleDateRange('yesterday')}>Yesterday</button>
// // //       <button onClick={() => handleDateRange('lastWeek')}>Last Week</button>
// // //       <button onClick={() => handleDateRange('lastMonth')}>Last Month</button>

// // //       <div>
// // //         <h3>Custom Range</h3>
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={(date) => setStartDate(date)}
// // //           selectsStart
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           maxDate={new Date()}
// // //           minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
// // //           placeholderText="Start Date"
// // //         />
// // //         <DatePicker
// // //           selected={endDate}
// // //           onChange={(date) => setEndDate(date)}
// // //           selectsEnd
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           maxDate={new Date()}
// // //           minDate={startDate || new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
// // //           placeholderText="End Date"
// // //         />
// // //         <button onClick={handleCustomRange}>Fetch Data</button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default DateFilterComponent;

// // // import React, { useState } from "react";
// // // import DatePicker from "react-datepicker";
// // // import "react-datepicker/dist/react-datepicker.css";

// // // const DateFilterComponent = ({ onDateRangeChange }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);

// // //   const handleDateRange = (range) => {
// // //     let start, end;
// // //     const today = new Date();

// // //     switch (range) {
// // //       case "today":
// // //         start = end = new Date();
// // //         break;
// // //       case "yesterday":
// // //         start = end = new Date(today.setDate(today.getDate() - 1));
// // //         break;
// // //       case "lastWeek":
// // //         start = new Date(today.setDate(today.getDate() - 7));
// // //         end = new Date();
// // //         break;
// // //       case "lastMonth":
// // //         start = new Date(today.setMonth(today.getMonth() - 1));
// // //         end = new Date();
// // //         break;
// // //       case "all":
// // //         start = null;
// // //         end = null;
// // //         break;
// // //       default:
// // //         start = null;
// // //         end = null;
// // //     }

// // //     setStartDate(start);
// // //     setEndDate(end);

// // //     onDateRangeChange({ start, end });
// // //   };

// // //   const handleCustomRange = () => {
// // //     onDateRangeChange({ start: startDate, end: endDate });
// // //   };

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-evenly whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>

// // //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("today")}>Today</button>
// // //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("yesterday")}>Yesterday</button>
// // //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastWeek")}>Last Week</button>
// // //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastMonth")}>Last Month</button>
// // //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("all")}>all</button>
// // //       </div>

// // //       <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full">
      
// // //         <DatePicker
// // //           selected={startDate}
// // //           onChange={(date) => setStartDate(date)}
// // //           selectsStart
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           maxDate={new Date()}
// // //           minDate={
// // //             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// // //           }
// // //           placeholderText="Start Date"
// // //           className='w-full shadow-sm border-[1px] border-gray-500  outline-none rounded-[8px] ' 
// // //         />
// // //         <DatePicker
// // //           selected={endDate}
// // //           onChange={(date) => setEndDate(date)}
// // //           selectsEnd
// // //           startDate={startDate}
// // //           endDate={endDate}
// // //           maxDate={new Date()}
// // //           minDate={
// // //             startDate ||
// // //             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// // //           }
// // //           placeholderText="End Date"
// // //           className='w-full shadow-sm border-[1px] border-gray-500  outline-none rounded-[8px]  '
// // //         />
// // //         <button onClick={handleCustomRange}>Fetch Data</button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default DateFilterComponent;

// // // import React, { useState, useEffect } from "react";
// // // import DatePicker from "react-datepicker";
// // // import "react-datepicker/dist/react-datepicker.css";

// // // const DateFilterComponent = ({ onDateRangeChange }) => {
// // //   const [startDate, setStartDate] = useState(null);
// // //   const [endDate, setEndDate] = useState(null);
// // //   const [showDatePicker, setShowDatePicker] = useState(false);

// // //   const handleDateRange = (range) => {
// // //     let start, end;
// // //     const today = new Date();

// // //     switch (range) {
// // //       case "today":
// // //         start = end = new Date();
// // //         break;
// // //       case "yesterday":
// // //         start = end = new Date(today.setDate(today.getDate() - 1));
// // //         break;
// // //       case "lastWeek":
// // //         start = new Date(today.setDate(today.getDate() - 7));
// // //         end = new Date();
// // //         break;
// // //       case "lastMonth":
// // //         start = new Date(today.setMonth(today.getMonth() - 1));
// // //         end = new Date();
// // //         break;
// // //       case "lastYear":
// // //         start = new Date(today.setFullYear(today.getFullYear() - 1));
// // //         end = new Date();
// // //         break;
// // //       case "all":
// // //         start = null;
// // //         end = null;
// // //         break;
// // //       default:
// // //         start = null;
// // //         end = null;
// // //     }

// // //     setStartDate(start);
// // //     setEndDate(end);

// // //     onDateRangeChange({ start, end });
// // //   };

// // //   const handleCustomRange = () => {
// // //     onDateRangeChange({ start: startDate, end: endDate });
// // //     setShowDatePicker(false); // Hide date picker after applying the range
// // //   };

// // //   useEffect(() => {
// // //     if (startDate !== null || endDate !== null) {
// // //       onDateRangeChange({ start: startDate, end: endDate });
// // //     }
// // //   }, [startDate, endDate]);

// // //   return (
// // //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-evenly whitespace-nowrap overflow-x-auto">
// // //       <div className='flex flex-row space-y-2'>
// // //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("today")}>Today</button>
// // //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("yesterday")}>Yesterday</button>
// // //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastWeek")}>Last Week</button>
// // //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastMonth")}>Last Month</button>
// // //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastYear")}>Last Year</button>
// // //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("all")}>All</button>
// // //       </div>

// // //       <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full">
// // //         <button
// // //           className="py-1 lg:px-2 px-4 bg-blue-500 text-white rounded ml-4"
// // //           onClick={() => setShowDatePicker(!showDatePicker)}
// // //         >
// // //           {showDatePicker ? "Hide Date Picker" : "Show Date Picker"}
// // //         </button>

// // //         {showDatePicker && (
// // //           <div className="mt-2">
// // //             <DatePicker
// // //               selected={startDate}
// // //               onChange={(dates) => {
// // //                 const [start, end] = dates;
// // //                 setStartDate(start);
// // //                 setEndDate(end);
// // //               }}
// // //               startDate={startDate}
// // //               endDate={endDate}
// // //               selectsRange
              
// // //               maxDate={new Date()}
// // //               minDate={
// // //                 new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// // //               }
// // //               placeholderText="Select date range"
// // //               className='w-full shadow-sm border-[1px] border-gray-500 outline-none rounded-[8px]'
// // //             />
// // //             <button
// // //               className="py-1 lg:px-2 px-4 bg-blue-500 text-white rounded ml-4 mt-2"
// // //               onClick={handleCustomRange}
// // //             >
// // //               Apply Date Range
// // //             </button>
// // //           </div>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default DateFilterComponent;


// // import React, { useState, useEffect } from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";

// // const DateFilterComponent = ({ onDateRangeChange }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const handleDateRange = (range) => {
// //     let start, end;
// //     const today = new Date();

// //     switch (range) {
// //       case "today":
// //         start = end = new Date();
// //         break;
// //       case "yesterday":
// //         start = end = new Date(today.setDate(today.getDate() - 1));
// //         break;
// //       case "lastWeek":
// //         start = new Date(today.setDate(today.getDate() - 7));
// //         end = new Date();
// //         break;
// //       case "lastMonth":
// //         start = new Date(today.setMonth(today.getMonth() - 1));
// //         end = new Date();
// //         break;
// //       case "lastYear":
// //         start = new Date(today.setFullYear(today.getFullYear() - 1));
// //         end = new Date();
// //         break;
// //       case "all":
// //         start = null;
// //         end = null;
// //         break;
// //       default:
// //         start = null;
// //         end = null;
// //     }

// //     setStartDate(start);
// //     setEndDate(end);

// //     onDateRangeChange({ start, end });
// //   };

// //   useEffect(() => {
// //     if (startDate !== null || endDate !== null) {
// //       onDateRangeChange({ start: startDate, end: endDate });
// //     }
// //   }, [startDate, endDate]);

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-evenly whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("today")}>Today</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("yesterday")}>Yesterday</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastWeek")}>Last Week</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastMonth")}>Last Month</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastYear")}>Last Year</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("all")}>All</button>
// //       </div>

// //       <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full">
// //         <DatePicker
// //           selected={startDate}
// //           onChange={(dates) => {
// //             const [start, end] = dates;
// //             setStartDate(start);
// //             setEndDate(end);
// //           }}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
          
// //           maxDate={new Date()}
// //           minDate={
// //             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// //           }
// //           placeholderText="Select date range"
// //           className='w-full shadow-sm border-[1px] border-gray-500 outline-none rounded-[8px]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default DateFilterComponent;
// import Image from 'next/image';
// import React, { useState , useEffect, useRef} from 'react';
// import { useCookies } from 'react-cookie';
// import { filter } from '../../../public/assets/icons';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DatePickes = ({ onDateRangeChange }) => {
//     const [activeDropDown, setActiveDropDown] = useState(false);
//     const [cookie, setCookie, removeCookies] = useCookies();
//     const dropdownRef = useRef(null);
  
//     const toggleDropDown = () => {
//       setActiveDropDown(prev => !prev);
//     };
//     const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//     const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);
  
//     const calculateDropdownPosition = () => {
//       if (dropdownRef.current) {
//         const buttonRect = dropdownRef.current.getBoundingClientRect();
//         return {
//           top: buttonRect.bottom + window.scrollY + 10,
//           left: buttonRect.left + window.scrollX,
//         };
//       }
//       return {};
//     };
  
//     useEffect(() => {
//       const handleResize = () => {
//         setIsSmallScreen(window.innerWidth <= 600);
//         setDropdownPosition(calculateDropdownPosition());
//       };
  
//       window.addEventListener('resize', handleResize);
//       setDropdownPosition(calculateDropdownPosition());
  
//       return () => window.removeEventListener('resize', handleResize);
//     }, []);
  
//     const styles = {
//       top: dropdownPosition.top,
//       ...(isSmallScreen && { left: dropdownPosition.left }),
//     };
  
  
//     // const dropdownPosition = calculateDropdownPosition();

    
//     const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleDateRange = (range) => {
//     let start, end;
//     const today = new Date();

//     switch (range) {
//       case "today":
//         start = end = new Date();
//         break;
//       case "yesterday":
//         start = end = new Date(today.setDate(today.getDate() - 1));
//         break;
//       case "lastWeek":
//         start = new Date(today.setDate(today.getDate() - 7));
//         end = new Date();
//         break;
//       case "lastMonth":
//         start = new Date(today.setMonth(today.getMonth() - 1));
//         end = new Date();
//         break;
//       case "lastYear":
//         start = new Date(today.setFullYear(today.getFullYear() - 1));
//         end = new Date();
//         break;
//       case "all":
//         start = null;
//         end = null;
//         break;
//       default:
//         start = null;
//         end = null;
//     }

//     setStartDate(start);
//     setEndDate(end);

//     onDateRangeChange({ start, end });
//   };

//   useEffect(() => {
//     if (startDate !== null || endDate !== null) {
//       onDateRangeChange({ start: startDate, end: endDate });
//     }
//   }, [startDate, endDate]);
  

//   return (
//     <div ref={dropdownRef} className='  flex justify-center items-center rounded-[8px] w-[48px] lg:mr-3 mr-7 '>
//       <button
//         className="m flex items-center justify-center"
//         onClick={toggleDropDown}
//       >
//         <Image src={filter} alt="dropdown arrow" />
//       </button>
      
//       {activeDropDown && (
//         <div className="absolute  z-50 px-2"
//         style={styles}
//         >

//           <div className="bg-white w-full shadow-xl  flex rounded-[6px] border-[1px] ">
//             <div className="py-2 px-4  lg:flex-row flex-col flex items-center relative ">
          
//           <p>  <button className="py-3 lg:px-2 px-4  text-[14px] text-[#000] h-[40px] w-[103px] my-2 font-[400]" onClick={() => handleDateRange("today")}>Today</button></p>
//           <p> <button className="py-3 lg:px-2 px-4  text-[14px] text-[#000] h-[40px] w-[103px] my-2 font-[400]" onClick={() => handleDateRange("yesterday")}>Yesterday</button></p>
//           <p>  <button className="py-3 lg:px-2 px-4  text-[14px] text-[#000] h-[40px] w-[103px] my-2 font-[400]" onClick={() => handleDateRange("lastWeek")}>Last Week</button></p>
//           <p> <button className="py-1 lg:px-2 px-4 text-[14px] text-[#000] h-[40px] w-[103px] my-2 font-[400]" onClick={() => handleDateRange("lastMonth")}>Last Month</button></p>
//           <p>   <button className="py-1 lg:px-2 px-4  text-[14px] text-[#000] h-[40px] w-[103px] my-2 font-[400]" onClick={() => handleDateRange("lastYear")}>Last Year</button></p>
//           <p> <button className="py-1 lg:px-2 px-4  text-[14px] text-[#000] h-[40px] w-[103px] my-2 font-[400]" onClick={() => handleDateRange("all")}>All</button></p>
//           <p></p>
//           <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper ">
//         <DatePicker
//           selected={startDate}
//           onChange={(dates) => {
//             const [start, end] = dates;
//             setStartDate(start);
//             setEndDate(end);
           
//           }}
//           startDate={startDate}
//           endDate={endDate}
//           selectsRange
          
//           maxDate={new Date()}
//           minDate={
//             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
//           }
//           placeholderText="Select date range"
//           className='w-full shadow-sm border-[1px] border-gray-500 outline-none rounded-[8px] z-[100%]'
//         />
//       </div>
       
      
       
     
       
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DatePickes;



















// // import Image from 'next/image';
// // import Router from 'next/router';
// // import FilterItem from './FilterItem';
// // import React, { useEffect, useState } from 'react';
// // import { useCookies } from 'react-cookie';
// // import {
// //     hamburgerMenu,
// //     profilePhoto,
// //     notificationBell,
// //     downArrow,
// //   } from "../../../public/assets/icons"
// // import {
// //   userLight,
// //   triangle,
// //   helpCenter,
// //   modalSettings,
// //   logout,
// //   check,
// // } from '../../../assets/icons';
// // import { logout as logoutFn } from '../../../utils/local-storage';
// // // import FilterItem from '../../elements/filter-menu-item';
// // import SidebarMenuItem from '../../elements/sidebar-menu-item';
// // import CalendarModal from '../../elements/calendar';

// // const Filter = ({ setLogoutLoading }) => {
// // //   const [active, setActive] = useState('yesterday');
// //   const [closeCalendar, setCloseCalendar] = useState(true);
// //   const [date, setDate] = useState([new Date(), new Date()]);
// //   const [cookie, setCookie, removeCookies] = useCookies();
// // //   const [showCalendarModal, setShowCalendarModal] = useState(false); // State to track the display of the calendar modal

// //   // Function to toggle the display of the calendar modal
// // //   const toggleCalendarModal = () => {
// // //     setShowCalendarModal(!showCalendarModal);
// // //   };

// //   const handleApply = () => {
// //     setCloseCalendar(true);
// //   };

// // const [active, setActive] = useState('yesterday');
// // const [dateRange, setDateRange] = useState({ start: null, end: null });
// // const [showCalendarModal, setShowCalendarModal] = useState(false);

// // const [dropdownVisible, setDropdownVisible] = useState(false); // State to track dropdown visibility

// //   // Function to toggle the display of the calendar modal

// //   // Function to toggle dropdown visibility
// //   const toggleDropdown = () => {
// //     setDropdownVisible(!dropdownVisible);
// //   };

// //   // Function to handle applying the date range from the calendar modal

// // // Function to toggle the display of the calendar modal
// // const toggleCalendarModal = () => {
// //   setShowCalendarModal(!showCalendarModal);
// // };

// // // Function to handle applying the date range from the calendar modal
// // const handleApplyDateRange = () => {
// //   // Close the modal
// //   toggleCalendarModal();
// //   // Logic to filter transactions based on the selected date range
// //   // You can implement this based on your application's data retrieval mechanism
// // };
// //   return (
// //     <section className=" relative  z-[100%] flex items-center flex-col w-full  justify-between ">
// //       <div className="absolute ml-32">
// //         <Image src={triangle} alt="triangle" />
// //       </div>

// //       <div className=" relative bg-dash-green py-2 pl-5 lg:w-[207px] w-full m-auto mt-3">

// //       <div className="dropdown-toggle  top-16 right-3 z-50 " onClick={toggleDropdown}>
// //           <p className="dropdown-title">Filters</p>
// //           <Image src={triangle} alt="dropdown" className={`dropdown-icon ${dropdownVisible ? 'open' : ''}`} />
// //         </div>
// //         {dropdownVisible && (

// //             <div className="dropdown-content ">
// //             <FilterItem
// //           title="Today"
// //           baseIcon={<Image src={userLight} alt="user light" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={() => setActive('today')}
// //           active={active === 'today'}
// //           // Implement filtering logic for 'Today'
// //         />
// //         <FilterItem
// //           title="Yesterday"
// //           baseIcon={<Image src={helpCenter} alt="help center" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={() => setActive('yesterday')}
// //           active={active === 'yesterday'}
// //           // Implement filtering logic for 'Yesterday'
// //         />

// //         <FilterItem
// //           title="Past Week"
// //           baseIcon={<Image src={helpCenter} alt="help center" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={() => setActive('Past Week')}
// //           active={active === 'Past Week'}

// //         />
// //         <FilterItem
// //           title="Past Month"
// //           baseIcon={<Image src={helpCenter} alt="help center" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={() => setActive('Past Month')}
// //           active={active === 'Past Month'}

// //         />
// //         <FilterItem
// //           title="Custom Range"
// //           baseIcon={<Image src={userLight} alt="user light" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={toggleCalendarModal}
// //           active={showCalendarModal}
// //         />
// //         <FilterItem
// //           title="Filter All"
// //           baseIcon={<Image src={userLight} alt="user light" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={toggleCalendarModal}
// //           active={showCalendarModal}
// //         />

// //         {showCalendarModal && (
// //           <CalendarModal
// //             closeCalendar={toggleCalendarModal}
// //           date={date}
// //           setDate={setDate}
// //           selectRange={true}
// //           handleApply={handleApply}// Pass toggle function as closeCalendar prop
// //             // Other props as needed
// //           />
// //         )}

// //         {/* <CalendarModal/> */}
// //         {/* <FilterItem
// //           title="Settings"
// //           baseIcon={<Image src={modalSettings} alt="modal settings" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={() => setActive('past-week')}
// //           active={active === 'past-week'}
// //           url="#"
// //         /> */}
// //         {/* <FilterItem
// //           title="Logout"
// //           baseIcon={<Image src={logout} alt="logout" />}
// //           activeIcon={<Image src={check} alt="check" />}
// //           onClick={() => {
// //             removeCookies('authToken', { path: '/' });
// //             removeCookies('user', { path: '/' });
// //             removeCookies('userId', { path: '/' });
// //             removeCookies('firstName', { path: '/' });
// //             removeCookies('role', { path: '/' });
// //             removeCookies('vendorId', { path: '/' });
// //             logoutFn();
// //             setLogoutLoading(true);
// //             Router.push('/');
// //             // setTimeout(() => Router.reload(), 1000);
// //           }}
// //           active={active === 'past-month'}
// //           // url="#"
// //         /> */}
// //       </div>
// //       )}
// //       </div>
// //     </section>
// //   );
// // };

// // export default Filter;
// // // {new Dat}

// // import React, { useState, useEffect } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { addDays, subDays, startOfWeek, startOfMonth, startOfYear, parseISO } from 'date-fns';

// // const FilterComponent = ({ data }) => {
// //   const [filteredData, setFilteredData] = useState([]);
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(today);
// //       setEndDate(today);
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(yesterday);
// //       setEndDate(yesterday);
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7));
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(lastWeekStart);
// //       setEndDate(lastWeekEnd);
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = subDays(today, 1);
// //       setStartDate(lastMonthStart);
// //       setEndDate(lastMonthEnd);
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   useEffect(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         const createdAt = parseISO(item.createdAt);
// //         return createdAt >= startDate && createdAt <= endDate;
// //       });
// //       setFilteredData(filtered);
// //     } else {
// //       setFilteredData(data);
// //     }
// //   }, [startDate, endDate, data]);

// //   return (
// //     <div>
// //       <div>
// //         <button onClick={filterOptions.today}>Today</button>
// //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// //         <button onClick={filterOptions.all}>All</button>
// //       </div>
// //       <div>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //         />
// //       </div>
// //       <div>
// //         {filteredData.map((item, index) => (
// //           <div key={index}>
// //             <p>{item.name}</p>
// //             <p>{item.createdAt}</p>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, parseISO } from 'date-fns';

// // const FilterComponent = ({ data }) => {
// //   const [filteredData, setFilteredData] = useState([]);
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   useEffect(() => {
// //     // Check if data is defined and not null before filtering
// //     if (data && data.length > 0) {
// //       setFilteredData(data);
// //     }
// //   }, [data]);

// //   // const filterOptions = {
// //   //   today: () => {
// //   //     const today = new Date();
// //   //     setStartDate(today);
// //   //     setEndDate(today);
// //   //   },
// //   //   yesterday: () => {
// //   //     const yesterday = subDays(new Date(), 1);
// //   //     setStartDate(yesterday);
// //   //     setEndDate(yesterday);
// //   //   },
// //   //   lastWeek: () => {
// //   //     const today = new Date();
// //   //     const lastWeekStart = startOfWeek(subDays(today, 7));
// //   //     const lastWeekEnd = subDays(today, 1);
// //   //     setStartDate(lastWeekStart);
// //   //     setEndDate(lastWeekEnd);
// //   //   },
// //   //   lastMonth: () => {
// //   //     const today = new Date();
// //   //     const lastMonthStart = startOfMonth(subDays(today, 30));
// //   //     const lastMonthEnd = subDays(today, 1);
// //   //     setStartDate(lastMonthStart);
// //   //     setEndDate(lastMonthEnd);
// //   //   },
// //   //   all: () => {
// //   //     setStartDate(null);
// //   //     setEndDate(null);
// //   //   }
// //   // };
// //   // const filterOptions = {
// //   //   today: () => {
// //   //     const today = new Date();
// //   //     setStartDate(today);
// //   //     setEndDate(today);
// //   //   },
// //   //   yesterday: () => {
// //   //     const yesterday = subDays(new Date(), 1);
// //   //     setStartDate(yesterday);
// //   //     setEndDate(yesterday);
// //   //   },
// //   //   lastWeek: () => {
// //   //     const today = new Date();
// //   //     const lastWeekStart = startOfWeek(subDays(today, 7));
// //   //     const lastWeekEnd = subDays(today, 1);
// //   //     setStartDate(lastWeekStart);
// //   //     setEndDate(lastWeekEnd);
// //   //   },
// //   //   lastMonth: () => {
// //   //     const today = new Date();
// //   //     const lastMonthStart = startOfMonth(subDays(today, 30));
// //   //     const lastMonthEnd = subDays(today, 1);
// //   //     setStartDate(lastMonthStart);
// //   //     setEndDate(lastMonthEnd);
// //   //   },
// //   //   all: () => {
// //   //     setStartDate(null);
// //   //     setEndDate(null);
// //   //   }
// //   // };

// //   const filterOptions = {
// //     today: () => {
// //       console.log("Filtering for today");
// //       const today = new Date();
// //       setStartDate(today);
// //       setEndDate(today);
// //     },
// //     yesterday: () => {
// //       console.log("Filtering for yesterday");
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(yesterday);
// //       setEndDate(yesterday);
// //     },
// //     lastWeek: () => {
// //       console.log("Filtering for last week");
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7));
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(lastWeekStart);
// //       setEndDate(lastWeekEnd);
// //     },
// //     lastMonth: () => {
// //       console.log("Filtering for last month");
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = subDays(today, 1);
// //       setStartDate(lastMonthStart);
// //       setEndDate(lastMonthEnd);
// //     },
// //     all: () => {
// //       console.log("Filtering for all");
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   // useEffect(() => {
// //   //   if (startDate && endDate) {
// //   //     const filtered = data.filter(item => {
// //   //       const createdAt = parseISO(item.createdAt);
// //   //       return createdAt >= startDate && createdAt <= endDate;
// //   //     });
// //   //     setFilteredData(filtered);
// //   //   } else {
// //   //     setFilteredData(data);
// //   //   }
// //   // }, [startDate, endDate, data]);
// //   useEffect(() => {
// //     console.log("Filtering data...");
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         const createdAt = parseISO(item.createdAt);
// //         return createdAt >= startDate && createdAt <= endDate;
// //       });
// //       setFilteredData(filtered);
// //     } else {
// //       setFilteredData(data);
// //     }
// //   }, [startDate, endDate, data]);

// //   // useEffect(() => {
// //   //   if (startDate && endDate) {
// //   //     const filtered = data.filter(item => {
// //   //       const createdAt = parseISO(item.createdAt);
// //   //       return createdAt >= startDate && createdAt <= endDate;
// //   //     });
// //   //     setFilteredData(filtered);
// //   //   } else {
// //   //     setFilteredData(data);
// //   //   }
// //   // }, [startDate, endDate, data]);

// //   return (
// //     <div>
// //       <div>
// //         <button onClick={filterOptions.today}>Today</button>
// //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// //         <button onClick={filterOptions.all}>All</button>
// //       </div>
// //       <div>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //         />
// //       </div>
// //       <div>
// //         {filteredData.map((item, index) => (
// //           <div key={index}>
// //             <p>{item.name}</p>
// //             <p>{item.createdAt}</p>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, parseISO } from 'date-fns';

// // const FilterComponent = ({ data, onFilter, }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(today);
// //       setEndDate(today);
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(yesterday);
// //       setEndDate(yesterday);
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7));
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(lastWeekStart);
// //       setEndDate(lastWeekEnd);
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = subDays(today, 1);
// //       setStartDate(lastMonthStart);
// //       setEndDate(lastMonthEnd);
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   useEffect(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         const createdAt = parseISO(item.createdAt);
// //         return createdAt >= startDate && createdAt <= endDate;
// //       });
// //       onFilter(filtered);
// //     } else {
// //       onFilter(data);
// //     }
// //   }, [startDate, endDate, data, onFilter]);

// //   return (
// //     <div className='w-1/2 flex items-center'>
// //       <div className='flex'>
// //         <button onClick={filterOptions.today}>Today</button>
// //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// //         <button onClick={filterOptions.all}>All</button>
// //       </div>
// //       <div>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // const FilterComponent = ({ data, onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 }); // Assuming week starts on Monday
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   useEffect(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         const createdAt = parseISO(item.createdAt);
// //         return createdAt >= startDate && createdAt <= endDate;
// //       });
// //       onFilter(filtered);
// //     } else {
// //       onFilter(data);
// //     }
// //   }, [startDate, endDate, data, onFilter]);

// //   return (
// //     <div className='w-1/2 flex items-center'>
// //       <div className='flex'>
// //         <button onClick={filterOptions.today}>Today</button>
// //         <button onClick={filterOptions.yesterday}>Yesterday</button>
// //         <button onClick={filterOptions.lastWeek}>Last Week</button>
// //         <button onClick={filterOptions.lastMonth}>Last Month</button>
// //         <button onClick={filterOptions.all}>All</button>
// //       </div>
// //       <div>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;
// // import React, { useState, useEffect, useCallback } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // const FilterComponent = ({ data, onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //       console.log('Today Start Date:', startDate);
// //       console.log('Today End Date:', endDate);
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 }); // Assuming week starts on Monday
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   const applyFilter = useCallback(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         const createdAt = parseISO(item.createdAt);
// //         return createdAt >= startDate && createdAt <= endDate;
// //       });
// //       console.log('Filtered Array:', filtered);
// //       onFilter(filtered);
// //     } else {
// //       onFilter(data);
// //     }
// //   }, [startDate, endDate, data, onFilter]);

// //   useEffect(() => {
// //     applyFilter();
// //   }, [applyFilter]);

// //   return (
// //     <div className=" mt-2  p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap">
// //         <div className='flex flex-row space-y-2 '>
// //             <button onClick={filterOptions.today} className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px]  w-auto lg:w-[100px]">Today</button>
// //             <button onClick={filterOptions.yesterday} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Yest<br className='lg:hidden flex'/>erday</button>
// //             <button onClick={filterOptions.lastWeek} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1  w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/> Week</button>
// //             <button onClick={filterOptions.lastMonth} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1  w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/>Month</button>
// //             <button onClick={filterOptions.all} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1  w-auto lg:w-[100px] text-[12px]">All</button>
// //           </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px]  outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>

// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect, useCallback } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // const FilterComponent = ({ data, onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);
// //  const filterComponent=({onFilterChange})=>{
// // const [filterTye, setFilterType]= useState(" ")
// // const [customRange, setCustomRange] = useState([null, null])
// // const handleFilterChange=()=>{

// // }
// //  }

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //       console.log('Today Start Date:', startDate);
// //       console.log('Today End Date:', endDate);
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //       console.log('Yesterday Start Date:', startDate);
// //       console.log('Yesterday End Date:', endDate);
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 }); // Assuming week starts on Monday
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //       console.log('Last Week Start Date:', startDate);
// //       console.log('Last Week End Date:', endDate);
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //       console.log('Last Month Start Date:', startDate);
// //       console.log('Last Month End Date:', endDate);
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   // const applyFilter = useCallback(() => {
// //   //   if (startDate && endDate) {
// //   //     const filtered = data.filter(item => {
// //   //       try {
// //   //         console.log('Original createdAt:', item.createdAt);
// //   //         const createdAt = parseISO(item.createdAt);
// //   //         return createdAt >= startDate && createdAt <= endDate;
// //   //       } catch (error) {
// //   //         console.error('Error parsing date:', item.createdAt, error);
// //   //         return false;
// //   //       }
// //   //     });
// //   //     console.log('Filtered Array:', filtered);
// //   //     onFilter(filtered);
// //   //   } else {
// //   //     onFilter(data);
// //   //   }
// //   // }, [startDate, endDate, data, onFilter]);
// //   const applyFilter = useCallback(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {

// //         if (item.createdAt) {
// //           try {
// //             console.log('Original createdAt:', item.createdAt);
// //             const createdAt = parseISO(item.createdAt);
// //             return createdAt >= startDate && createdAt <= endDate;
// //           } catch (error) {
// //             console.error('Error parsing date:', item.createdAt, error);
// //             return false;
// //           }
// //         } else {
// //           return false; // Skip items without a valid createdAt property
// //         }
// //       });
// //       console.log('Filtered Array:', filtered);
// //       onFilter(filtered);
// //     } else {
// //       onFilter(data);
// //     }
// //   }, [startDate, endDate, data, onFilter]);
// //   useEffect(() => {
// //     applyFilter();
// //   }, [applyFilter]);

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap">
// //       <div className='flex flex-row space-y-2'>
// //         <button

// //         onClick={() => filterOptions.today()}
// //         className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">Today</button>
// //         <button onClick={()=>filterOptions.yesterday()} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Yest<br className='lg:hidden flex'/>erday</button>
// //         <button onClick={filterOptions.lastWeek} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/> Week</button>
// //         <button onClick={filterOptions.lastMonth} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">Last <br className='lg:hidden flex'/>Month</button>
// //         <button onClick={filterOptions.all} className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">All</button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect, useCallback } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO, lastDayOfYear, startOfYear, endOfYear } from 'date-fns';

// // const FilterComponent = ({ data, onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   const applyFilter = useCallback(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         if (item.launchDate) {
// //           try {
// //             const launchDate = parseISO(item.launchDate);
// //             return launchDate >= startDate && launchDate <= endDate;
// //           } catch (error) {
// //             console.error('Error parsing date:', item.launchDate, error);
// //             return false;
// //           }
// //         } else {
// //           return false;
// //         }
// //       });
// //       onFilter(filtered);
// //     } else {
// //       onFilter(data);
// //     }
// //   }, [startDate, endDate, data, onFilter]);

// //   useEffect(() => {
// //     applyFilter();
// //   }, [applyFilter]);

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap">
// //       <div className='flex flex-row space-y-2'>
// //         <button
// //           onClick={() => filterOptions.today()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// //           Today
// //         </button>
// //         <button
// //           onClick={() => filterOptions.yesterday()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Yesterday
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastWeek()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Week
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastMonth()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Month
// //         </button>
// //         <button
// //           onClick={() => filterOptions.all()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           All
// //         </button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect, useCallback } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { subDays, startOfWeek, startOfMonth, endOfMonth, parseISO } from 'date-fns';

// // const FilterComponent = ({ data, onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     },
// //     // lastDayOfYear: () => {
// //     //   const today = new Date();
// //     //   const lastMonthStart = startOfYear(subDays(today, 365));
// //     //   const lastMonthEnd = endOfYear(subDays(today, 365));
// //     //   setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //     //   setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     // },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   const applyFilter = useCallback(() => {
// //     if (startDate && endDate) {
// //       const filtered = data.filter(item => {
// //         const dateField = item.launchDate || item.createdAt || item.Date;
// //         if (dateField) {
// //           try {
// //             const date = parseISO(dateField);
// //             return date >= startDate && date <= endDate;
// //           } catch (error) {
// //             console.error('Error parsing date:', dateField, error);
// //             return false;
// //           }
// //         } else {
// //           return false;
// //         }
// //       });
// //       onFilter(filtered);
// //     } else {
// //       onFilter(data);
// //     }
// //   }, [startDate, endDate, data, onFilter]);

// //   useEffect(() => {
// //     applyFilter();
// //   }, [applyFilter]);

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button
// //           onClick={() => filterOptions.today()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// //           Today
// //         </button>
// //         <button
// //           onClick={() => filterOptions.yesterday()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Yesterday
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastWeek()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Week
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastMonth()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Month
// //         </button>
// //         {/* <button
// //           onClick={() => filterOptions.lastDayOfYear()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Year
// //         </button> */}
// //         <button
// //           onClick={() => filterOptions.all()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           All
// //         </button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useCallback, useEffect } from 'react';
// // import DatePicker from 'react-datepicker';
// // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { fetchAffiliateRecentSales } from '../../../api-client/dashboard';
// // // import { fetchAffiliateRecentSales } from './api'; // Adjust the import based on your project structure

// // const FilterComponent = ({ token, onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   const applyFilter = useCallback(() => {
// //     const pageNumber = 1; // Adjust as necessary
// //     const pageSize = 25; // Adjust as necessary
// //     const searchText = ""; // Adjust as necessary

// //     fetchAffiliateRecentSales({ token, pageNumber, pageSize, searchText, startDate, endDate })
// //       .then(response => onFilter(response.data))
// //       .catch(error => console.error('Error fetching data:', error));
// //   }, [startDate, endDate, token, onFilter]);

// //   useEffect(() => {
// //     applyFilter();
// //   }, [applyFilter]);

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button
// //           onClick={() => filterOptions.today()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// //           Today
// //         </button>
// //         <button
// //           onClick={() => filterOptions.yesterday()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Yesterday
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastWeek()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Week
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastMonth()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Month
// //         </button>
// //         <button
// //           onClick={() => filterOptions.all()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           All
// //         </button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState, useEffect, useCallback } from 'react';
// // import DatePicker from 'react-datepicker';
// // import "react-datepicker/dist/react-datepicker.css";
// // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';

// // const FilterComponent = ({ onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       setStartDate(new Date(today.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(today.setHours(23, 59, 59, 999)));
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       setStartDate(new Date(yesterday.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(yesterday.setHours(23, 59, 59, 999)));
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// //       const lastWeekEnd = subDays(today, 1);
// //       setStartDate(new Date(lastWeekStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastWeekEnd.setHours(23, 59, 59, 999)));
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       setStartDate(new Date(lastMonthStart.setHours(0, 0, 0, 0)));
// //       setEndDate(new Date(lastMonthEnd.setHours(23, 59, 59, 999)));
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //   };

// //   const applyFilter = useCallback(() => {
// //     onFilter({ startDate, endDate });
// //   }, [startDate, endDate, onFilter]);

// //   useEffect(() => {
// //     applyFilter();
// //   }, [applyFilter, startDate, endDate]);
// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button
// //           onClick={() => filterOptions.today()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// //           Today
// //         </button>
// //         <button
// //           onClick={() => filterOptions.yesterday()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Yesterday
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastWeek()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Week
// //         </button>
// //         <button
// //           onClick={() => filterOptions.lastMonth()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Month
// //         </button>
// //         <button
// //           onClick={() => filterOptions.all()}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           All
// //         </button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState } from 'react';
// // import DatePicker from 'react-datepicker';
// // import "react-datepicker/dist/react-datepicker.css";
// // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';

// // const FilterComponent = ({ onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       const start = new Date(today.setHours(0, 0, 0, 0));
// //       const end = new Date(today.setHours(23, 59, 59, 999));
// //       setStartDate(start);
// //       setEndDate(end);
// //       onFilter({ startDate: start, endDate: end });
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       const start = new Date(yesterday.setHours(0, 0, 0, 0));
// //       const end = new Date(yesterday.setHours(23, 59, 59, 999));
// //       setStartDate(start);
// //       setEndDate(end);
// //       onFilter({ startDate: start, endDate: end });
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// //       const lastWeekEnd = subDays(today, 1);
// //       const start = new Date(lastWeekStart.setHours(0, 0, 0, 0));
// //       const end = new Date(lastWeekEnd.setHours(23, 59, 59, 999));
// //       setStartDate(start);
// //       setEndDate(end);
// //       onFilter({ startDate: start, endDate: end });
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       const start = new Date(lastMonthStart.setHours(0, 0, 0, 0));
// //       const end = new Date(lastMonthEnd.setHours(23, 59, 59, 999));
// //       setStartDate(start);
// //       setEndDate(end);
// //       onFilter({ startDate: start, endDate: end });
// //     },
// //     all: () => {
// //       setStartDate(null);
// //       setEndDate(null);
// //       onFilter({ startDate: null, endDate: null });
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setStartDate(start);
// //     setEndDate(end);
// //     onFilter({ startDate: start, endDate: end });
// //   };

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button
// //           onClick={filterOptions.today}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// //           Today
// //         </button>
// //         <button
// //           onClick={filterOptions.yesterday}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Yesterday
// //         </button>
// //         <button
// //           onClick={filterOptions.lastWeek}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Week
// //         </button>
// //         <button
// //           onClick={filterOptions.lastMonth}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Month
// //         </button>
// //         <button
// //           onClick={filterOptions.all}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           All
// //         </button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState } from 'react';
// // import DatePicker from 'react-datepicker';
// // import "react-datepicker/dist/react-datepicker.css";
// // import { subDays, startOfWeek, startOfMonth, endOfMonth } from 'date-fns';
// // import { useCookies } from 'react-cookie';

// // const FilterComponent = ({ onFilter }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);
// //   const [cookies, setCookie] = useCookies(['filter']);

// //   const setFilter = (start, end) => {
// //     setStartDate(start);
// //     setEndDate(end);
// //     onFilter({ startDate: start, endDate: end });

// //     // Set the filter in cookies
// //     setCookie('filter', { startDate: start, endDate: end }, { path: '/' });
// //   };

// //   const filterOptions = {
// //     today: () => {
// //       const today = new Date();
// //       const start = new Date(today.setHours(0, 0, 0, 0));
// //       const end = new Date(today.setHours(23, 59, 59, 999));
// //       setFilter(start, end);
// //     },
// //     yesterday: () => {
// //       const yesterday = subDays(new Date(), 1);
// //       const start = new Date(yesterday.setHours(0, 0, 0, 0));
// //       const end = new Date(yesterday.setHours(23, 59, 59, 999));
// //       setFilter(start, end);
// //     },
// //     lastWeek: () => {
// //       const today = new Date();
// //       const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 });
// //       const lastWeekEnd = subDays(today, 1);
// //       const start = new Date(lastWeekStart.setHours(0, 0, 0, 0));
// //       const end = new Date(lastWeekEnd.setHours(23, 59, 59, 999));
// //       setFilter(start, end);
// //     },
// //     lastMonth: () => {
// //       const today = new Date();
// //       const lastMonthStart = startOfMonth(subDays(today, 30));
// //       const lastMonthEnd = endOfMonth(subDays(today, 30));
// //       const start = new Date(lastMonthStart.setHours(0, 0, 0, 0));
// //       const end = new Date(lastMonthEnd.setHours(23, 59, 59, 999));
// //       setFilter(start, end);
// //     },
// //     all: () => {
// //       setFilter(null, null);
// //     }
// //   };

// //   const handleCustomRange = (dates) => {
// //     const [start, end] = dates;
// //     setFilter(start, end);
// //   };

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-between whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button
// //           onClick={filterOptions.today}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded whitespace-nowrap lg:mx-5 mx-1 text-[12px] w-auto lg:w-[100px]">
// //           Today
// //         </button>
// //         <button
// //           onClick={filterOptions.yesterday}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Yesterday
// //         </button>
// //         <button
// //           onClick={filterOptions.lastWeek}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Week
// //         </button>
// //         <button
// //           onClick={filterOptions.lastMonth}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           Last Month
// //         </button>
// //         <button
// //           onClick={filterOptions.all}
// //           className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]">
// //           All
// //         </button>
// //       </div>
// //       <div className='lg:mt-0 mt-3 lg:p-0 p-2 lg:w-fit w-full'>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={handleCustomRange}
// //           startDate={startDate}
// //           endDate={endDate}
// //           selectsRange
// //           maxDate={new Date()}
// //           minDate={subDays(new Date(), 365 * 3)}
// //           placeholderText="Custom Range"
// //           className='w-full shadow-sm border-[1px] outline-none rounded-[8px] border-[#B3BAC5]'
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // export default FilterComponent;

// // import React, { useState } from 'react';
// // import DatePicker from 'react-datepicker';
// // import 'react-datepicker/dist/react-datepicker.css';
// // import { fetchAffiliateRecentSales } from './yourApiFile';

// // const DateFilterComponent = ({ token }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const handleDateRange = (range) => {
// //     let start, end;
// //     const today = new Date();

// //     switch (range) {
// //       case 'today':
// //         start = end = new Date();
// //         break;
// //       case 'yesterday':
// //         start = end = new Date(today.setDate(today.getDate() - 1));
// //         break;
// //       case 'lastWeek':
// //         start = new Date(today.setDate(today.getDate() - 7));
// //         end = new Date();
// //         break;
// //       case 'lastMonth':
// //         start = new Date(today.setMonth(today.getMonth() - 1));
// //         end = new Date();
// //         break;
// //       default:
// //         start = null;
// //         end = null;
// //     }

// //     setStartDate(start);
// //     setEndDate(end);

// //     fetchSalesData(start, end);
// //   };

// //   const fetchSalesData = (start, end) => {
// //     fetchAffiliateRecentSales({ token, startDate: start, endDate: end })
// //       .then(response => {
// //         console.log('Data fetched successfully:', response.data);
// //       })
// //       .catch(error => {
// //         console.error('Error fetching data:', error);
// //       });
// //   };

// //   const handleCustomRange = () => {
// //     fetchSalesData(startDate, endDate);
// //   };

// //   return (
// //     <div>
// //       <button onClick={() => handleDateRange('today')}>Today</button>
// //       <button onClick={() => handleDateRange('yesterday')}>Yesterday</button>
// //       <button onClick={() => handleDateRange('lastWeek')}>Last Week</button>
// //       <button onClick={() => handleDateRange('lastMonth')}>Last Month</button>

// //       <div>
// //         <h3>Custom Range</h3>
// //         <DatePicker
// //           selected={startDate}
// //           onChange={(date) => setStartDate(date)}
// //           selectsStart
// //           startDate={startDate}
// //           endDate={endDate}
// //           maxDate={new Date()}
// //           minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
// //           placeholderText="Start Date"
// //         />
// //         <DatePicker
// //           selected={endDate}
// //           onChange={(date) => setEndDate(date)}
// //           selectsEnd
// //           startDate={startDate}
// //           endDate={endDate}
// //           maxDate={new Date()}
// //           minDate={startDate || new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
// //           placeholderText="End Date"
// //         />
// //         <button onClick={handleCustomRange}>Fetch Data</button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DateFilterComponent;

// // import React, { useState } from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";

// // const DateFilterComponent = ({ onDateRangeChange }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);

// //   const handleDateRange = (range) => {
// //     let start, end;
// //     const today = new Date();

// //     switch (range) {
// //       case "today":
// //         start = end = new Date();
// //         break;
// //       case "yesterday":
// //         start = end = new Date(today.setDate(today.getDate() - 1));
// //         break;
// //       case "lastWeek":
// //         start = new Date(today.setDate(today.getDate() - 7));
// //         end = new Date();
// //         break;
// //       case "lastMonth":
// //         start = new Date(today.setMonth(today.getMonth() - 1));
// //         end = new Date();
// //         break;
// //       case "all":
// //         start = null;
// //         end = null;
// //         break;
// //       default:
// //         start = null;
// //         end = null;
// //     }

// //     setStartDate(start);
// //     setEndDate(end);

// //     onDateRangeChange({ start, end });
// //   };

// //   const handleCustomRange = () => {
// //     onDateRangeChange({ start: startDate, end: endDate });
// //   };

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-evenly whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>

// //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("today")}>Today</button>
// //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("yesterday")}>Yesterday</button>
// //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastWeek")}>Last Week</button>
// //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastMonth")}>Last Month</button>
// //       <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("all")}>all</button>
// //       </div>

// //       <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full">

// //         <DatePicker
// //           selected={startDate}
// //           onChange={(date) => setStartDate(date)}
// //           selectsStart
// //           startDate={startDate}
// //           endDate={endDate}
// //           maxDate={new Date()}
// //           minDate={
// //             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// //           }
// //           placeholderText="Start Date"
// //           className='w-full shadow-sm border-[1px] border-gray-500  outline-none rounded-[8px] '
// //         />
// //         <DatePicker
// //           selected={endDate}
// //           onChange={(date) => setEndDate(date)}
// //           selectsEnd
// //           startDate={startDate}
// //           endDate={endDate}
// //           maxDate={new Date()}
// //           minDate={
// //             startDate ||
// //             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// //           }
// //           placeholderText="End Date"
// //           className='w-full shadow-sm border-[1px] border-gray-500  outline-none rounded-[8px]  '
// //         />
// //         <button onClick={handleCustomRange}>Fetch Data</button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DateFilterComponent;

// // import React, { useState, useEffect } from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";

// // const DateFilterComponent = ({ onDateRangeChange }) => {
// //   const [startDate, setStartDate] = useState(null);
// //   const [endDate, setEndDate] = useState(null);
// //   const [showDatePicker, setShowDatePicker] = useState(false);

// //   const handleDateRange = (range) => {
// //     let start, end;
// //     const today = new Date();

// //     switch (range) {
// //       case "today":
// //         start = end = new Date();
// //         break;
// //       case "yesterday":
// //         start = end = new Date(today.setDate(today.getDate() - 1));
// //         break;
// //       case "lastWeek":
// //         start = new Date(today.setDate(today.getDate() - 7));
// //         end = new Date();
// //         break;
// //       case "lastMonth":
// //         start = new Date(today.setMonth(today.getMonth() - 1));
// //         end = new Date();
// //         break;
// //       case "lastYear":
// //         start = new Date(today.setFullYear(today.getFullYear() - 1));
// //         end = new Date();
// //         break;
// //       case "all":
// //         start = null;
// //         end = null;
// //         break;
// //       default:
// //         start = null;
// //         end = null;
// //     }

// //     setStartDate(start);
// //     setEndDate(end);

// //     onDateRangeChange({ start, end });
// //   };

// //   const handleCustomRange = () => {
// //     onDateRangeChange({ start: startDate, end: endDate });
// //     setShowDatePicker(false); // Hide date picker after applying the range
// //   };

// //   useEffect(() => {
// //     if (startDate !== null || endDate !== null) {
// //       onDateRangeChange({ start: startDate, end: endDate });
// //     }
// //   }, [startDate, endDate]);

// //   return (
// //     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-evenly whitespace-nowrap overflow-x-auto">
// //       <div className='flex flex-row space-y-2'>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("today")}>Today</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("yesterday")}>Yesterday</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastWeek")}>Last Week</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastMonth")}>Last Month</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastYear")}>Last Year</button>
// //         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("all")}>All</button>
// //       </div>

// //       <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full">
// //         <button
// //           className="py-1 lg:px-2 px-4 bg-blue-500 text-white rounded ml-4"
// //           onClick={() => setShowDatePicker(!showDatePicker)}
// //         >
// //           {showDatePicker ? "Hide Date Picker" : "Show Date Picker"}
// //         </button>

// //         {showDatePicker && (
// //           <div className="mt-2">
// //             <DatePicker
// //               selected={startDate}
// //               onChange={(dates) => {
// //                 const [start, end] = dates;
// //                 setStartDate(start);
// //                 setEndDate(end);
// //               }}
// //               startDate={startDate}
// //               endDate={endDate}
// //               selectsRange

// //               maxDate={new Date()}
// //               minDate={
// //                 new Date(new Date().setFullYear(new Date().getFullYear() - 3))
// //               }
// //               placeholderText="Select date range"
// //               className='w-full shadow-sm border-[1px] border-gray-500 outline-none rounded-[8px]'
// //             />
// //             <button
// //               className="py-1 lg:px-2 px-4 bg-blue-500 text-white rounded ml-4 mt-2"
// //               onClick={handleCustomRange}
// //             >
// //               Apply Date Range
// //             </button>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default DateFilterComponent;

// import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DateFilterComponent = ({ onDateRangeChange }) => {
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleDateRange = (range) => {
//     let start, end;
//     const today = new Date();

//     switch (range) {
//       case "today":
//         start = end = new Date();
//         break;
//       case "yesterday":
//         start = end = new Date(today.setDate(today.getDate() - 1));
//         break;
//       case "lastWeek":
//         start = new Date(today.setDate(today.getDate() - 7));
//         end = new Date();
//         break;
//       case "lastMonth":
//         start = new Date(today.setMonth(today.getMonth() - 1));
//         end = new Date();
//         break;
//       case "lastYear":
//         start = new Date(today.setFullYear(today.getFullYear() - 1));
//         end = new Date();
//         break;
//       case "all":
//         start = null;
//         end = null;
//         break;
//       default:
//         start = null;
//         end = null;
//     }

//     setStartDate(start);
//     setEndDate(end);

//     onDateRangeChange({ start, end });
//   };

//   useEffect(() => {
//     if (startDate !== null || endDate !== null) {
//       onDateRangeChange({ start: startDate, end: endDate });
//     }
//   }, [startDate, endDate]);

//   return (
//     <div className="mt-2 p-0 lg:p-4 bg-white border border-gray-200 rounded shadow-lg flex-col lg:flex-row flex items-center justify-evenly whitespace-nowrap overflow-x-auto">
//       <div className='flex flex-row space-y-2'>
//         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("today")}>Today</button>
//         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("yesterday")}>Yesterday</button>
//         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastWeek")}>Last Week</button>
//         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastMonth")}>Last Month</button>
//         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("lastYear")}>Last Year</button>
//         <button className="py-1 lg:px-2 px-4 bg-gray-100 rounded lg:mx-5 mx-1 w-auto lg:w-[100px] text-[12px]" onClick={() => handleDateRange("all")}>All</button>
//       </div>

//       <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full">
//         <DatePicker
//           selected={startDate}
//           onChange={(dates) => {
//             const [start, end] = dates;
//             setStartDate(start);
//             setEndDate(end);
//           }}
//           startDate={startDate}
//           endDate={endDate}
//           selectsRange

//           maxDate={new Date()}
//           minDate={
//             new Date(new Date().setFullYear(new Date().getFullYear() - 3))
//           }
//           placeholderText="Select date range"
//           className='w-full shadow-sm border-[1px] border-gray-500 outline-none rounded-[8px]'
//         />
//       </div>
//     </div>
//   );
// };

// export default DateFilterComponent;
// import Image from "next/image";
// import React, { useState, useEffect, useRef } from "react";
// import { useCookies } from "react-cookie";
// import { filter } from "../../../public/assets/icons";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DatePickes = ({ onDateRangeChange }) => {
//   const [activeDropDown, setActiveDropDown] = useState(false);
//   const [cookie, setCookie, removeCookies] = useCookies();
//   const dropdownRef = useRef(null);

//   const toggleDropDown = () => {
//     setActiveDropDown((prev) => !prev);
//   };
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);

//   const calculateDropdownPosition = () => {
//     if (dropdownRef.current) {
//       const buttonRect = dropdownRef.current.getBoundingClientRect();
//       return {
//         top: buttonRect.bottom + window.scrollY + 10,
//         left: buttonRect.left + window.scrollX,
//       };
//     }
//     return {};
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth <= 600);
//       setDropdownPosition(calculateDropdownPosition());
//     };

//     window.addEventListener("resize", handleResize);
//     setDropdownPosition(calculateDropdownPosition());

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const styles = {
//     top: dropdownPosition.top,
//     ...(isSmallScreen && { left: dropdownPosition.left }),
//   };

//   // const dropdownPosition = calculateDropdownPosition();

//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleDateRange = (range) => {
//     let start, end;
//     const today = new Date();

//     switch (range) {
//       case "today":
//         start = end = new Date();
//         break;
//       case "yesterday":
//         start = end = new Date(today.setDate(today.getDate() - 1));
//         break;
//       case "lastWeek":
//         start = new Date(today.setDate(today.getDate() - 7));
//         end = new Date();
//         break;
//       case "lastMonth":
//         start = new Date(today.setMonth(today.getMonth() - 1));
//         end = new Date();
//         break;
//       case "lastYear":
//         start = new Date(today.setFullYear(today.getFullYear() - 1));
//         end = new Date();
//         break;
//       case "all":
//         start = null;
//         end = null;
//         break;
//       default:
//         start = null;
//         end = null;
//     }

//     setStartDate(start);
//     setEndDate(end);

//     onDateRangeChange({ start, end });
//   };

//   useEffect(() => {
//     if (startDate !== null || endDate !== null) {
//       onDateRangeChange({ start: startDate, end: endDate });
//     }
//   }, [startDate, endDate]);

//   return (
//     <div
//       ref={dropdownRef}
//       className="   bg-white"
//     >
//       <button
//         className="m flex items-center justify-center"
//         onClick={toggleDropDown}
//       >
//         <Image src={filter} alt="dropdown arrow" />
//       </button>

//       {activeDropDown && (
//         <div className="date-filter absolute lg:w-[500px] h-[300px]">
//             <div className="date-options">
//               <p>
//                 {" "}
//                 <button
//                   className="py-3 lg:px-2 px-4  text-[14px] text-[#000]  w-[103px] font-[400] border-2"
//                   onClick={() => handleDateRange("today")}
//                 >
//                   Today
//                 </button>
//               </p>
//               <p>
//                 {" "}
//                 <button
//                   className="py-3 lg:px-2 px-4  text-[14px] text-[#000]  w-[103px] font-[400] border-2"
//                   onClick={() => handleDateRange("yesterday")}
//                 >
//                  Last 7 days
//                 </button>
//               </p>
//               <p>
//                 {" "}
//                 <button
//                   className="py-3 lg:px-2 px-4  text-[14px] text-[#000]  w-[103px] font-[400] border-2"
//                   onClick={() => handleDateRange("lastWeek")}
//                 >
//                30 days
//                 </button>
//               </p>
//               <p>
//                 {" "}
//                 <button
//                   className="py-1 lg:px-2 px-4 text-[14px] text-[#000]  w-[103px] font-[400] border-2"
//                   onClick={() => handleDateRange("lastMonth")}
//                 >
//                 1 year
//                 </button>
//               </p>
            
//               <p></p>
//             </div>
//               <div className="flex lg:mt-0 mt-3 lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper custom-date ">
//           <div className="bg-white w-full shadow-xl  flex rounded-[6px] border-[1px] ">
//                 <DatePicker
//                   selected={startDate}
//                   onChange={(dates) => {
//                     const [start, end] = dates;
//                     setStartDate(start);
//                     setEndDate(end);
//                   }}
//                   startDate={startDate}
//                   endDate={endDate}
//                   selectsRange
//                   maxDate={new Date()}
//                   minDate={
//                     new Date(
//                       new Date().setFullYear(new Date().getFullYear() - 3)
//                     )
//                   }
//                   placeholderText="Select date range"
//                   className="w-full shadow-sm border-[1px] border-gray-500 outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DatePickes;


// import React, { useState, useRef, useEffect } from "react";
// import { useCookies } from "react-cookie";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import Image from "next/image";
// import filter from "path-to-filter-image"; // Update the path accordingly

// const DatePickes = ({ onDateRangeChange }) => {
//   const [activeDropDown, setActiveDropDown] = useState(false);
//   const [cookie, setCookie, removeCookies] = useCookies();
//   const dropdownRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedRange, setSelectedRange] = useState(null);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const toggleDropDown = () => {
//     setActiveDropDown((prev) => !prev);
//   };

//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);

//   const calculateDropdownPosition = () => {
//     if (dropdownRef.current) {
//       const buttonRect = dropdownRef.current.getBoundingClientRect();
//       return {
//         top: buttonRect.bottom + window.scrollY + 10,
//         left: buttonRect.left + window.scrollX,
//       };
//     }
//     return {};
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth <= 600);
//       setDropdownPosition(calculateDropdownPosition());
//     };

//     window.addEventListener("resize", handleResize);
//     setDropdownPosition(calculateDropdownPosition());

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const styles = {
//     top: dropdownPosition.top,
//     ...(isSmallScreen && { left: dropdownPosition.left }),
//   };

//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleApplyFilter = (rangeType) => {
//     let start, end;
//     const today = new Date();

//     switch (rangeType) {
//       case "today":
//         start = new Date(today);
//         start.setHours(0, 0, 0, 0);
//         end = new Date(today);
//         end.setHours(23, 59, 59, 999);
//         break;
//       case "yesterday":
//         start = new Date(today);
//         start.setDate(today.getDate() - 1);
//         start.setHours(0, 0, 0, 0);
//         end = new Date(today);
//         end.setDate(today.getDate() - 1);
//         end.setHours(23, 59, 59, 999);
//         break;
//       case "last7days":
//         start = new Date(today);
//         start.setDate(today.getDate() - 7);
//         start.setHours(0, 0, 0, 0);
//         end = new Date(today);
//         end.setHours(23, 59, 59, 999);
//         break;
//       case "30days":
//         start = new Date(today);
//         start.setDate(today.getDate() - 30);
//         start.setHours(0, 0, 0, 0);
//         end = new Date(today);
//         end.setHours(23, 59, 59, 999);
//         break;
//       case "1year":
//         start = new Date(today);
//         start.setFullYear(today.getFullYear() - 1);
//         start.setHours(0, 0, 0, 0);
//         end = new Date(today);
//         end.setHours(23, 59, 59, 999);
//         break;
//       default:
//         start = startDate;
//         end = endDate;
//         break;
//     }

//     setSelectedRange(rangeType);
//     onDateRangeChange({ start, end });
//     setActiveDropDown(false);
//   };

//   const handleClear = () => {
//     setStartDate(null);
//     setEndDate(null);
//     setSelectedRange(null);
//     onDateRangeChange({ start: null, end: null });
//   };

//   return (
//     <div ref={dropdownRef} className="bg-white m-2 w-auto">
//       <button className="m flex items-center justify-center" onClick={toggleDropDown}>
//         <Image src={filter} alt="dropdown arrow" />
//       </button>

//       {activeDropDown && (
//         <div className="date-filter absolute lg:w-auto h-[299px] border-2 px-3 rounded-l-[24px] rounded-br-[24px]">
//           <div className="date-options bottom-0">
//             <p>
//               <button
//                 className={`py-3 lg:px-2 px-4 text-[14px] font-[400] border-2 ${selectedRange === "today" ? "text-pink-500" : "text-blue-500"}`}
//                 onClick={() => handleApplyFilter("today")}
//               >
//                 Today
//               </button>
//             </p>
//             <p>
//               <button
//                 className={`py-3 lg:px-2 px-4 text-[14px] font-[400] border-2 ${selectedRange === "yesterday" ? "text-pink-500" : "text-blue-500"}`}
//                 onClick={() => handleApplyFilter("yesterday")}
//               >
//                 Yesterday
//               </button>
//             </p>
//             <p>
//               <button
//                 className={`py-3 lg:px-2 px-4 text-[14px] font-[400] border-2 ${selectedRange === "last7days" ? "text-pink-500" : "text-blue-500"}`}
//                 onClick={() => handleApplyFilter("last7days")}
//               >
//                 Last 7 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className={`py-3 lg:px-2 px-4 text-[14px] font-[400] border-2 ${selectedRange === "30days" ? "text-pink-500" : "text-blue-500"}`}
//                 onClick={() => handleApplyFilter("30days")}
//               >
//                 30 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className={`py-3 lg:px-2 px-4 text-[14px] font-[400] border-2 ${selectedRange === "1year" ? "text-pink-500" : "text-blue-500"}`}
//                 onClick={() => handleApplyFilter("1year")}
//               >
//                 1 year
//               </button>
//             </p>
//           </div>

//           <div className="lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper custom-date">
//             <div className="bg-white w-full shadow-xl rounded-[6px]">
//               <p className="text-[#282828] text-[14px] font-[400] my-2">Custom Date</p>
//               <div className="w-full">
//                 <label>From</label>
//                 <DatePicker
//                   selected={startDate}
//                   onChange={(date) => setStartDate(date)}
//                   maxDate={new Date()}
//                   minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
//                   placeholderText="Select start date"
//                   className="w-[100%] shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//               <div className="w-full">
//                 <label>To</label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={(date) => setEndDate(date)}
//                   maxDate={new Date()}
//                   minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
//                   placeholderText="Select end date"
//                   className="w-full shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="flex justify-end mt-4">
//             <button
//               className="py-2 px-4 bg-[#205363] w-[146px] h-[44px] text-white rounded mr-2"
//               onClick={() => handleApplyFilter()}
//             >
//               Apply Filter
//             </button>
//             <button
//               className="py-2 px-4 border-[#205363] border-[1px] text-[#205363] w-[108px] rounded"
//               onClick={handleClear}
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DatePickes;

import Image from "next/image";
import React, { useState, useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import { filter } from "../../../public/assets/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";








const DatePickes = ({ onDateRangeChange }) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropDown, setActiveDropDown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropDown = () => {
    setActiveDropDown((prev) => !prev);
  };

  const calculateDropdownPosition = () => {
    if (dropdownRef.current) {
      const buttonRect = dropdownRef.current.getBoundingClientRect();
      return {
        top: buttonRect.bottom + window.scrollY + 10,
        left: buttonRect.left + window.scrollX,
      };
    }
    return { top: 0, left: 0 };
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600);
      setDropdownPosition(calculateDropdownPosition());
    };

    if (typeof window !== 'undefined') {
      setIsSmallScreen(window.innerWidth <= 600);
      setDropdownPosition(calculateDropdownPosition());
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  const styles = {
    top: dropdownPosition.top,
    ...(isSmallScreen && { left: dropdownPosition.left }),
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleApplyFilter = (rangeType) => {
    let start, end;
    const today = new Date();

    switch (rangeType) {
      case "today":
        start = new Date(today);
        start.setHours(0, 0, 0, 0);
        end = new Date(today);
        end.setHours(23, 59, 59, 999);
        break;
      case "yesterday":
        start = new Date(today);
        start.setDate(today.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        end = new Date(today);
        end.setDate(today.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        break;
      case "last7days":
        start = new Date(today);
        start.setDate(today.getDate() - 7);
        start.setHours(0, 0, 0, 0);
        end = new Date(today);
        end.setHours(23, 59, 59, 999);
        break;
      case "30days":
        start = new Date(today);
        start.setDate(today.getDate() - 30);
        start.setHours(0, 0, 0, 0);
        end = new Date(today);
        end.setHours(23, 59, 59, 999);
        break;
      case "1year":
        start = new Date(today);
        start.setFullYear(today.getFullYear() - 1);
        start.setHours(0, 0, 0, 0);
        end = new Date(today);
        end.setHours(23, 59, 59, 999);
        break;
      default:
        start = startDate;
        end = endDate;
        break;
    }

    onDateRangeChange({ start, end });
    setSelectedFilter(rangeType);
    setActiveDropDown(false);
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedFilter(null);
    onDateRangeChange({ start: null, end: null });
  };

  return (
    <div ref={dropdownRef} className="bg-white m-2 w-auto">
      <button className="m flex items-center justify-center" onClick={toggleDropDown}>
        <Image src={filter} alt="dropdown arrow" />
      </button>

      {activeDropDown && (
        <div className="date-filter absolute lg:w-auto h-[325px] z-50 border-2 lg:px-10 px-4 rounded-l-[24px] rounded-br-[24px] shadow-xl  mx-2">
          <div className="date-options bottom-0 lg:mt-5 mt-0">
            <p className="lg:px-2 px-0">
              <button
              className={`py-3 lg:px-0 px-2 text-[14px] text-[#000] font-[400] border-2 ${selectedFilter === 'today' ? 'border-b-[1px] text-[#205363] font-bold' : ''}`}
                onClick={() => handleApplyFilter("today")}
              >
                Today
              </button>
            </p>
            {/* <p>
              <button
                className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
                onClick={() => handleApplyFilter("yesterday")}
              >
                Yesterday
              </button>
            </p> */}
            <p className="lg:px-2 px-0">
              <button
              className={`py-3 lg:px-0 px-2 text-[14px] text-[#000] font-[400] border-2 ${selectedFilter === 'last7days' ? 'text-[#205363] font-bold' : ''}`}
              onClick={() => handleApplyFilter("last7days")}
              >
                Last 7 days
              </button>
            </p>
            <p className="lg:px-2 px-0">
              <button
              className={`py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2 ${selectedFilter === '30days' ? ' text-[#205363] font-bold' : ''}`}
              onClick={() => handleApplyFilter("30days")}
              >
                30 days
              </button>
            </p>
            <p className="lg:px-2 px-0">
              <button
              className={`py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2 ${selectedFilter === '1year' ? 'text-[#205363] font-bold' : ''}`}
              onClick={() => handleApplyFilter("1year")}
              >
                1 year
              </button>
            </p>
          </div>

          <div className="lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper custom-date">
            <div className="bg-white w-full  rounded-[6px]">
              <p className="text-[#282828] text-[14px] font-[400] my-2">Custom Date</p>
              <div className="w-full">
                <label>From</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  maxDate={new Date()}
                  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
                  placeholderText="Select start date"
                  className="w-[100%] shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
                />
              </div>
              <div className="w-full">
                <label>To</label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  maxDate={new Date()}
                  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
                  placeholderText="Select end date"
                  className="w-full shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between mt-4">
            <button
              className="py-2 px-4 bg-[#205363] w-[146px] h-[44px] text-white rounded mr-2"
              onClick={() => handleApplyFilter()}
            >
              Apply Filter
            </button>
            <button
              className="py-2 px-4 border-[#205363] border-[1px] text-[#205363] w-[108px] rounded"
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePickes;




// const DatePickes = ({ onDateRangeChange }) => {
//   const [activeDropDown, setActiveDropDown] = useState(false);
//   const [cookie, setCookie, removeCookies] = useCookies();
//   const dropdownRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const toggleDropDown = () => {
//     setActiveDropDown((prev) => !prev);
//   };

//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);

//   const calculateDropdownPosition = () => {
//     if (dropdownRef.current) {
//       const buttonRect = dropdownRef.current.getBoundingClientRect();
//       return {
//         top: buttonRect.bottom + window.scrollY + 10,
//         left: buttonRect.left + window.scrollX,
//       };
//     }
//     return {};
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth <= 600);
//       setDropdownPosition(calculateDropdownPosition());
//     };

//     window.addEventListener("resize", handleResize);
//     setDropdownPosition(calculateDropdownPosition());

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const styles = {
//     top: dropdownPosition.top,
//     ...(isSmallScreen && { left: dropdownPosition.left }),
//   };

//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleApplyFilter = (rangeType) => {
//     let start, end;
//     const today = new Date();

//     switch (rangeType) {
//       case "today":
//         start = end = new Date(today.setHours(0, 0, 0, 0));
//         break;
//       case "last7days":
//         start = new Date(today.setDate(today.getDate() - 7));
//         start.setHours(0, 0, 0, 0);
//         end = new Date();
//         break;
//       case "30days":
//         start = new Date(today.setDate(today.getDate() - 30));
//         start.setHours(0, 0, 0, 0);
//         end = new Date();
//         break;
//       case "1year":
//         start = new Date(today.setFullYear(today.getFullYear() - 1));
//         start.setHours(0, 0, 0, 0);
//         end = new Date();
//         break;
//       default:
//         start = startDate;
//         end = endDate;
//         break;
//     }

//     onDateRangeChange({ start, end });
//     setActiveDropDown(false);
//   };

//   const handleClear = () => {
//     setStartDate(null);
//     setEndDate(null);
//     onDateRangeChange({ start: null, end: null });
//   };

//   return (
//     <div ref={dropdownRef} className="bg-white m-2 w-auto">
//       <button className="m flex items-center justify-center" onClick={toggleDropDown}>
//         <Image src={filter} alt="dropdown arrow" />
//       </button>

//       {activeDropDown && (
//         <div className="date-filter absolute lg:w-auto h-[299px] border-2 px-3 rounded-l-[24px] rounded-br-[24px]">
//           <div className="date-options bottom-0">
//             <p className="">
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("today")}
//               >
//                 Today
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("last7days")}
//               >
//                 Last 7 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("30days")}
//               >
//                 30 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("1year")}
//               >
//                 1 year
//               </button>
//             </p>
//           </div>

//           <div className="lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper custom-date">
//             <div className="bg-white w-full shadow-xl rounded-[6px]">
//               <p className="text-[#282828] text-[14px] font-[400] my-2">Custom Date</p>
//               <div className="w-full">
//                 <label>From</label>
//                 <DatePicker
//                   selected={startDate}
//                   onChange={(date) => setStartDate(date)}
//                   maxDate={new Date()}
//                   minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
//                   placeholderText="Select start date"
//                   className="w-[100%] shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//               <div className="w-full">
//                 <label>To</label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={(date) => setEndDate(date)}
//                   maxDate={new Date()}
//                   minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
//                   placeholderText="Select end date"
//                   className="w-full shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="flex justify-end mt-4">
//             <button
//               className="py-2 px-4 bg-[#205363] w-[146px] h-[44px] text-white rounded mr-2"
//               onClick={() => handleApplyFilter()}
//             >
//               Apply Filter
//             </button>
//             <button
//               className="py-2 px-4 border-[#205363] border-[1px] text-[#205363] w-[108px] rounded"
//               onClick={handleClear}
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DatePickes;



// const DatePickes = ({ onDateRangeChange }) => {
//   const [activeDropDown, setActiveDropDown] = useState(false);
//   const [cookie, setCookie, removeCookies] = useCookies();
//   const dropdownRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const toggleDropDown = () => {
//     setActiveDropDown((prev) => !prev);
//   };

//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);

//   const calculateDropdownPosition = () => {
//     if (dropdownRef.current) {
//       const buttonRect = dropdownRef.current.getBoundingClientRect();
//       return {
//         top: buttonRect.bottom + window.scrollY + 10,
//         left: buttonRect.left + window.scrollX,
//       };
//     }
//     return {};
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth <= 600);
//       setDropdownPosition(calculateDropdownPosition());
//     };

//     window.addEventListener("resize", handleResize);
//     setDropdownPosition(calculateDropdownPosition());

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const styles = {
//     top: dropdownPosition.top,
//     ...(isSmallScreen && { left: dropdownPosition.left }),
//   };

//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleApplyFilter = (rangeType) => {
//     let start, end;

//     const today = new Date();
//     switch (rangeType) {
//       case "today":
//         start = end = today;
//         break;
//       case "last7days":
//         start = new Date(today);
//         start.setDate(today.getDate() - 7);
//         end = today;
//         break;
//       case "30days":
//         start = new Date(today);
//         start.setDate(today.getDate() - 30);
//         end = today;
//         break;
//       case "1year":
//         start = new Date(today);
//         start.setFullYear(today.getFullYear() - 1);
//         end = today;
//         break;
//       default:
//         start = startDate;
//         end = endDate;
//         break;
//     }

//     onDateRangeChange({ start, end });
//     setActiveDropDown(false);
//   };

//   const handleClear = () => {
//     setStartDate(null);
//     setEndDate(null);
//     onDateRangeChange({ start: null, end: null });
//   };

//   return (
//     <div ref={dropdownRef} className="bg-white m-2 w-auto">
//       <button className="m flex items-center justify-center" onClick={toggleDropDown}>
//         <Image src={filter} alt="dropdown arrow" />
//       </button>

//       {activeDropDown && (
//         <div className="date-filter absolute lg:w-auto h-[299px] border-2 px-3 rounded-l-[24px] rounded-br-[24px]">
//           <div className="date-options bottom-0">
//             <p className="">
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("today")}
//               >
//                 Today
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("last7days")}
//               >
//                 Last 7 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("30days")}
//               >
//                 30 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000] font-[400] border-2"
//                 onClick={() => handleApplyFilter("1year")}
//               >
//                 1 year
//               </button>
//             </p>
//           </div>

//           <div className="lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper custom-date">
//             <div className="bg-white w-full shadow-xl rounded-[6px]">
//               <p className="text-[#282828] text-[14px] font-[400] my-2">Custom Date</p>
//               <div className="w-full">
//                 <label>From</label>
//                 <DatePicker
//                   selected={startDate}
//                   onChange={(date) => setStartDate(date)}
//                   maxDate={new Date()}
//                   minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
//                   placeholderText="Select start date"
//                   className="w-[100%] shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//               <div className="w-full">
//                 <label>To</label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={(date) => setEndDate(date)}
//                   maxDate={new Date()}
//                   minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 3))}
//                   placeholderText="Select end date"
//                   className="w-full shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="flex justify-end mt-4">
//             <button
//               className="py-2 px-4 bg-[#205363] w-[146px] h-[44px] text-white rounded mr-2"
//               onClick={() => handleApplyFilter()}
//             >
//               Apply Filter
//             </button>
//             <button
//               className="py-2 px-4 border-[#205363] border-[1px] text-[#205363] w-[108px] rounded"
//               onClick={handleClear}
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DatePickes;

// const DatePickes = ({ onDateRangeChange }) => {
//   const [activeDropDown, setActiveDropDown] = useState(false);
//   const [cookie, setCookie, removeCookies] = useCookies();
//   const dropdownRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const toggleDropDown = () => {
//     setActiveDropDown((prev) => !prev);
//   };

//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);

//   const calculateDropdownPosition = () => {
//     if (dropdownRef.current) {
//       const buttonRect = dropdownRef.current.getBoundingClientRect();
//       return {
//         top: buttonRect.bottom + window.scrollY + 10,
//         left: buttonRect.left + window.scrollX,
//       };
//     }
//     return {};
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth <= 600);
//       setDropdownPosition(calculateDropdownPosition());
//     };

//     window.addEventListener("resize", handleResize);
//     setDropdownPosition(calculateDropdownPosition());

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const styles = {
//     top: dropdownPosition.top,
//     ...(isSmallScreen && { left: dropdownPosition.left }),
//   };

//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);

//   const handleApplyFilter = () => {
//     onDateRangeChange({ start: startDate, end: endDate });
//     setActiveDropDown(false);
//   };

//   const handleClear = () => {
//     setStartDate(null);
//     setEndDate(null);
//     onDateRangeChange({ start: null, end: null });
//   };

//   return (
//     <div ref={dropdownRef} className="bg-white m-2 w-auto">
//       <button className="m flex items-center justify-center" onClick={toggleDropDown}>
//         <Image src={filter} alt="dropdown arrow" />
//       </button>

//       {activeDropDown && (
//         <div className="date-filter absolute lg:w-auto h-[299px] border-2 px-3 rounded-l-[24px] rounded-br-[24px]">
//           <div className="date-options bottom-0 ">
//           <p className="">
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000]   font-[400] border-2"
//                 onClick={() => handleApplyFilter()}
//               >
//                 Today
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000]   font-[400] border-2"
//                 onClick={() => handleApplyFilter()}
//               >
//                 Last 7 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000]   font-[400] border-2"
//                 onClick={() => handleApplyFilter()}
//               >
//                 30 days
//               </button>
//             </p>
//             <p>
//               <button
//                 className="py-3 lg:px-2 px-4 text-[14px] text-[#000]   font-[400] border-2"
//                 onClick={() => handleApplyFilter()}
//               >
//                 1 year
//               </button>
//             </p>
//           </div>

//           <div className="   lg:p-0 p-2 lg:w-auto w-full react-datepicker-popper custom-date">
//             <div className="bg-white w-full shadow-xl  rounded-[6px]  ">
//               <p className="text-[#282828] text-[14px] font-[400] my-2">Custom Date</p>
//               <div className="w-full  ">
//                 <label>From</label>
//                 <DatePicker
//                   selected={startDate}
//                   onChange={(date) => setStartDate(date)}
//                   maxDate={new Date()}
//                   minDate={
//                     new Date(new Date().setFullYear(new Date().getFullYear() - 3))
//                   }
//                   placeholderText="Select start date"
//                   className="w-[100%] shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//               <div className="w-full ">
//                 <label>To</label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={(date) => setEndDate(date)}
//                   maxDate={new Date()}
//                   minDate={
//                     new Date(new Date().setFullYear(new Date().getFullYear() - 3))
//                   }
//                   placeholderText="Select end date"
//                   className="w-full shadow-sm border-[1px] py-2 mt-2 border-[#06193829] outline-none rounded-[8px] z-[100%]"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="flex justify-end mt-4">
//             <button
//               className="py-2 px-4 bg-[#205363] w-[146px] h-[44px] text-white rounded mr-2"
//               onClick={handleApplyFilter}
//             >
//               Apply Filter
//             </button>
//             <button
//               className="py-2 px-4 border-[#205363] border-[1px] text-[#205363] w-[108px] rounded"
//               onClick={handleClear}
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DatePickes;
